<template>
  <div v-if="preloader">
    <template>
      <v-dialog v-model="preloader" hide-overlay persistent width="300">
        <v-progress-linear indeterminate></v-progress-linear>
      </v-dialog>
    </template>
  </div>
  <div v-else>
    <div class="d-flex flex-column pb-0 px-8 interview-main--container">
      <v-card
        height="64px"
        width="100%"
        class="background transparent header fixed elevation-0 d-flex flex-row justify-space-between align-center pt-2"
      >
        <v-card-title class="pl-0 ml-0">
          <p
            class="breadcrumb-text-unselected underline-on-hover cursor"
            @click="$router.push('/campaign')"
          >
            Campaigns
          </p>
          <v-icon
            class="breadcrumb-arrow-unselected"
            style="margin-top: 6px !important"
            >mdi-chevron-right</v-icon
          >

          <p
            class="breadcrumb-text-unselected underline-on-hover cursor"
            @click="backToCampaignUserListingPage"
          >
            {{ campaignName }}
          </p>
          <v-icon
            class="breadcrumb-arrow-unselected"
            style="margin-top: 6px !important"
            >mdi-chevron-right</v-icon
          >
          <p class="breadcrumb-text" style="margin-top: 2px">
            {{isSchedule ? 'Schedule': 'Edit'}} Interview
          </p>
          <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important"
            >mdi-chevron-down</v-icon
          >
        </v-card-title>
        <UserNavMenu/>
      </v-card>
      <section class="d-flex flex-column flex-1">
        <p class="text-h6">{{isSchedule ? 'Schedule': 'Edit'}} Interview</p>

        <v-card class="mb-4">
          <div class="schedule-card--container rounded-lg pa-4 d-flex align-center">
            <div id="first-box" class="d-flex align-center flex-1">
              <div>
                <v-img
                  contain
                  src="../assets/avtar.png"
                  height="48px"
                  width="48px">
                </v-img>
              </div>
              <div class="mr-auto">
                <p class="ml-4 text-subtitle-2" v-if="this.userData.personalInfo.firstName">
                  {{ userData.personalInfo?.firstName + " " + this.userData.personalInfo.lastName | capitalizeFirst }}
                </p>
                <p class="ml-4 text-subtitle-2 text-lowercase" v-if="userData.personalInfo.contactInfo.email">
                  {{ userData.personalInfo.contactInfo.email }}
                </p>
              </div>
              <v-divider vertical></v-divider>
            </div>
            <div class="second-box d-flex align-center flex-1">
              <div id="level-subject" class="w-100 pr-4">
                <div class="d-flex subject-level--container preferred-level--container">
                  <span class="interview-text--label">
                    Preferred Level
                  </span>
                  <span> - </span>
                  <v-tooltip v-if="userData.teachingInterests?.levels?.length > 2" bottom style="z-index: 999">
                    <template v-slot:activator="{ on, attrs }">
                      <p v-bind="attrs" v-on="on" role-type="subtitle-3" class="interview-text--value">
                        {{ userData.teachingInterests?.levels?.join(", ") }}
                      </p>
                    </template>
                    <span>{{ userData.teachingInterests?.levels?.join(", ") }}</span>
                  </v-tooltip>
                  <p v-else role-type="subtitle-3">
                    {{this.userData.teachingInterests?.levels?.join(", ")}}
                  </p>
                </div>
                <div class="d-flex subject-level--container">
                  <span class="interview-text--label">
                    Preferred Subjects
                  </span>
                  <span> - </span>
                  <v-tooltip v-if="userData.teachingInterests?.subjects?.length > 2" bottom style="z-index: 999">
                    <template v-slot:activator="{ on, attrs }">
                      <p v-bind="attrs" v-on="on" role-type="subtitle-3" class="interview-text--value">
                        {{ userData.teachingInterests?.subjects?.join(", ")}}
                      </p>
                    </template>
                    <span>{{ userData.teachingInterests?.subjects?.join(", ") }}</span>
                  </v-tooltip>
                  <p v-else role-type="subtitle-3" class="interview-text--value">
                    {{ this.userData.teachingInterests?.subjects?.join(", ")}}
                  </p>
                </div>
              </div>
              <v-divider vertical></v-divider>
            </div>
            <div class="second-box d-flex justify-space-between flex-1">
              <div id="role-localtion">
                <div class="d-flex align-center job-role--container">
                  <span class="interview-text--label interview-job--location">
                    Preferred Job role
                  </span>
                  <span> - </span>
                  <v-tooltip v-if="userData.teachingInterests?.jobRole?.HRIS_unique_role?.length > 30" bottom style="z-index: 999">
                    <template v-slot:activator="{ on, attrs }">
                      <p v-bind="attrs" v-on="on" role-type="subtitle-3" class="interview-text--value">
                        {{ userData.teachingInterests?.jobRole?.HRIS_unique_role }}
                      </p>
                    </template>
                    <span>{{ userData.teachingInterests?.jobRole?.HRIS_unique_role }}</span>
                  </v-tooltip>
                  <p v-else role-type="subtitle-3" class="interview-text--value">
                    {{
                      this.userData.teachingInterests?.jobRole?.HRIS_unique_role
                    }}
                  </p>
                </div>
                <div class="d-flex align-center job-role--container">
                  <span class="interview-text--label interview-job--location">
                    Preferred Location
                  </span>
                  <span>-</span>
                  <p role-type="subtitle-3" class="interview-text--value">
                    {{ this.userData.teachingInterests.schools }}
                  </p>
                </div>
                </div>
              </div>
            </div>
        </v-card>
        <v-card class="rounded-lg mb-4"  v-if="showStep1 && showSchool">
          <div class="pa-4 d-flex align-center">
            <p class="font-14">School</p>
            <span class="mx-4">-</span>
            <p role-type="subtitle-4"> {{ this.userData.teachingInterests.schools }} </p>
          </div>
        </v-card>


        <div class="side-container my-3" v-if="showStep2" >
            <div class="d-flex align-center">
              <span class="round-text text-h6">
                Round {{ this.roundToggleIndex+1 }} Details
              </span>
              <div class="w-100 toggle-btn--container" v-if="showToggleBtn">
                <v-btn-toggle
                  v-model="roundToggleIndex"
                  mandatory
                  dense
                  rounded
                  @change="updateRoundFeedback"
                >
                  <v-btn
                  v-for="(round, index) in rounds"
                  class="skill-btn"
                  :class="
                  roundToggleIndex == index
                  ? 'gray-05 blue--text caption white'
                  : 'caption white'
                  " :key="round"
                  >
                  Round {{ round }}
                  </v-btn>
                </v-btn-toggle>
                </div>
              </div>
            <p class="d-flex pl-0" role-type="subtitle-4">Interviewer’s Comment</p>
            <v-row>
                <v-col cols="4" class="pl-2 pr-4" v-for="data in currentRoundFeedback">
                    <div class="rounded-xl elevation-3 pa-4 current-round--card cursror-pointer	"  :class="data.bgClass" @click="showInterviewReport">
                      <div>
                          <p class="interview-user--email mb-2">{{ getInterviewerDisplayText(data.interviewerEmail) }}</p>
                          <div class="d-flex interview-details">
                            <span class="interview-card--label">Score</span>
                            <span> - </span>
                            <span>{{ data.avgScore }}</span>
                          </div>
                          <div class="d-flex interview-details">
                            <span class="interview-card--label">Recommendation</span>
                            <span> - </span>
                            <span>{{ data.interviewerRecommendation  }}</span>
                          </div>

                          <div class="d-flex interview-details">
                            <span class="interview-card--label">Comment</span>
                            <span> - </span>
                            <v-tooltip bottom >
                              <template v-slot:activator="{ on, attrs }">
                                <span class="interview-round--comment flex-1 " v-bind="attrs" v-on="on" >{{data.remark}}</span>
                              </template>
                              <span>{{data.remark}}</span>
                          </v-tooltip>

                          </div>
                      </div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
            <v-col  v-if="getHiringManagerRemark">
              <p role-type="subtitle-4" class="pl-2">Hiring Manager's Comment</p>
              <div class="rounded-xl elevation-3 pa-4">
                      <div>
                          <div class="d-flex interview-details">
                            <span class="interview-card--label">Hiring Manger</span>
                            <span> - </span>
                            <span>{{ selectedManager.hiringManagerName }} ({{selectedManager.hiringManagerEmail  }})</span>
                          </div>
                          <div class="d-flex interview-details">
                            <span class="interview-card--label">Decision</span>
                            <span> - </span>
                            <span>Schedule Next Round</span>
                          </div>
                          <div class="d-flex interview-details">
                            <span class="interview-card--label">Comment</span>
                            <span> - </span>
                            <span v-html="getHiringManagerRemark?.remark ?? 'Comment not Provided'"></span>
                          </div>


                      </div>
              </div></v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <v-row>
             <v-col cols="5">
              <div class="d-flex align-center h-100">
                <div class="pa-4 d-flex flex-column my-card rounded-lg">
                  <p class="font-16 mb-3">Schedule</p>
                  <p role-type="body-5" class="mb-6"> Schedule a new interview by adding the interviewer's email ID and selecting available time slots.</p>
                  <div class="d-flex justify-center">
                    <v-btn
                      width="225px"
                      height="48px"
                      :loading="loading"
                      :disabled="newRoundSchedule || disableActionSchedule"
                      rounded
                      @click="ScheduleNewInterViewRound"
                      class="btn primary-btn"
                      >Schedule </v-btn
                    >
                  </div>
                </div>
              </div>
             </v-col>

            </v-row>

           <v-divider class="mt-7"></v-divider>
        </div>
         <v-container fluid v-if="showStep1" ref="InterviewSchedule">
          <v-row class="schedule-columns-row no-scroll-x">
            <v-col cols="6" class="pa-0 schedule-lhs-col">
              <div class="side-container schedule-lhs-panel">
                <p role-type="body-3" class="font-weight-bold mb-0">{{isSchedule ? 'Schedule Interview': 'Edit Interview'}}  - Round {{ round }} </p>
                <div id="right-container" class="d-flex flex-column schedule-lhs-scroll">
                  <div>
                    <v-radio-group v-model="interviewMode" row class="h-50px mt-0">
                    <v-radio
                      key="Online"
                      :label="`Online`"
                      value="Online"
                    ></v-radio>
                        <v-radio
                      key="Offline"
                      :label="`Offline`"
                      value="Offline"
                    ></v-radio>
                  </v-radio-group>
                    <div v-if="interviewMode == 'Offline'" class="mb-4">
                      <div v-if="!schoolAddressError">
                      <p role-type="subtitle-6" >Address</p>
                       <p class="mt-1" role-type="body-4-gray">{{ schoolAddress }}</p>
                       </div>
                       <div v-else>
                        <p class="mt-1 text--error">
                        Please contact
                        <a href="mailto:hubblestar.support@hubblehox.com">
                          hubblestar.support@hubblehox.com
                        </a>
                        for assistance with changing this location.
                      </p> </div>
                       <div>
                      </div>
                    </div>
                      <v-card class="date-time-selection-card pa-4 pa-md-6 mt-0 mb-4" outlined elevation="2">
                        <div class="d-flex justify-space-between align-center flex-wrap mb-5 date-time-selection-header">
                          <p class="text-subtitle-2 mb-0">Select Date & Time</p>
                          <v-btn
                          class="clear-selection text-subtitle-2"
                            rounded
                            depressed
                            :disabled="slotStatus=='PENDING' || !hasDateTimeSelection"
                            @click="clearDateTimeSelection"
                          >
                            Clear Selection
                          </v-btn>
                        </div>

                        <div v-if="hasDateTimeSelection && currentSlotId && !slotsData.some(s => s.slotDate === currentSlotId)" class="selected-slot-info mb-4">
                          <p class="mb-2">Scheduled Date & Time</p>
                          <p class="mb-2">{{ requestedSlotDateTime }}</p>
                          <p class="mb-2">The scheduled date has already passed, so it is no longer available in the slots below</p>
                        </div>

                        <div class="date-time-selection-body">
                          <div class="mb-5">
                            <p class="text-body-2 mb-3">Select Date</p>
                            <div class="date-selection-grid">
                              <button
                                v-for="(data, index) in this.slotsData"
                                :key="data.slotDate"
                                type="button"
                                class="date-selection-item"
                                :class="{ 'date-selection-item--active': currentSlotId === data.slotDate && !disableThreeToFiveSlots && hasInterviewerAndHiringManager, 'date-selection-item--disabled': disableThreeToFiveSlots || !hasInterviewerAndHiringManager }"
                                :disabled="disableThreeToFiveSlots || !hasInterviewerAndHiringManager"
                                @click="findTimeSlots(index)"
                              >
                                <span class="date-selection-item__weekday">
                                  {{ getDateCardWeekday(data) }}
                                </span>
                                <span class="date-selection-item__date">
                                  {{ getDateCardLabel(data) }}
                                </span>
                              </button>
                            </div>
                          </div>

                          <div class="mb-4">
                            <p class="text-body-2 mb-3">Select Slot</p>
                            <v-item-group class="schedule-card date-slot-grid">
                              <v-item
                                v-for="data in this.currentTimeSlots"
                                :key="data.index"
                                class="slot-item"
                                v-slot="{ toggle }"
                              >
                                <v-card
                                  @click="setCurrentTimeSlotIndex(data.index, data.slotStart)"
                                  :disabled="disableThreeToFiveSlots || !hasInterviewerAndHiringManager"
                                  :ripple="!disableThreeToFiveSlots && hasInterviewerAndHiringManager"
                                  :class="
                                    currentTimeSlotIndex?.toString() === data.index?.toString() && !disableThreeToFiveSlots && hasInterviewerAndHiringManager
                                      ? 'SI-time-card-active'
                                      : 'SI-time-card'
                                  "
                                  class="date-slot-item rounded-lg text-center align-center d-flex justify-center py-3 px-3"
                                >
                                  {{ data.slotStart }} - {{ data.slotEnd }}
                                </v-card>
                              </v-item>
                            </v-item-group>
                          </div>

                          <div class="date-time-selection-footer">
                            <p class="date-time-selection-or mb-0">OR</p>
                            <div class="date-time-selection-request">
                              <p class="date-time-selection-help mb-0">
                                <span help-text-required></span>                        </p>
                              <v-btn
                                rounded
                                outlined
                                class="btn outline-btn request-slot-trigger"
                                @click="openRequestSlotDialog"
                                :disabled="disableRequestSlotButton || !hasSelectedInterviewers"
                              > {{ requestSlotButtonLabel }} Slot
                              </v-btn>
                            </div>
                          </div>

                          <div
                            v-if="(requiresApprovalFlow || slotStatus) && !disableRequestSlotButton"
                            class="requested-slot-info mt-5"
                            :class="{ 'requested-slot-info--rejected': isSlotRejected && !requiresApprovalFlow }"
                          >
                            <p class="date-time-selection-help mb-1">Requested Slot</p>
                            <p class="date-time-selection-help mb-3">{{ requestedSlotDateTime }}</p>

                            <!-- Approver + status reflect a previously submitted request.
                                 While editing (a new slot was just picked from the dialog,
                                 requiresApprovalFlow) overwrite them and show only the new
                                 requested date & time range. -->
                            <template v-if="slotStatus && !requiresApprovalFlow">
                              <p class="date-time-selection-help mb-1">Approver</p>
                              <p class="date-time-selection-help mb-3">{{ approverDetails?.name }} - {{ approverDetails?.email }}</p>

                              <p class="date-time-selection-help mb-0">
                                Requested slot is <span class="text-capitalize">{{ slotStatus.toLocaleLowerCase() }}</span>
                              </p>
                            </template>
                          </div>
                        </div>
                      </v-card>
                  </div>
                     <div class="mb-5" v-if="isHiringManagerHierarchyEnabled">
                        <p role-type="subtitle-5"  ><span v-if="currentHiringManagerRoleLabel">{{ currentHiringManagerRoleLabel }} </span>Hiring Manager's HRIS Unique role</p>
                       <p class="mt-1" role-type="body-4-gray">
                         <span v-if="currentHiringManagerHrisRole">{{ currentHiringManagerHrisRole }}</span>
                       </p>
                      </div>
                  <div class="mb-3" >
                   <!-- Read-only hiring manager panel. Only rendered once the hierarchy
                        flow is live; with the flag off the manager is picked through the
                        Hiring Manager autocomplete further down instead. -->
                   <template v-if="isHiringManagerHierarchyEnabled">
                     <p class="mb-1" role-type="subtitle-5"><span v-if="currentHiringManagerRoleLabel">{{ currentHiringManagerRoleLabel }} </span>Hiring Manager</p>
                     <p v-if="currentHiringManager" class="text-body-1 mb-0" role-type="subtitle-6">
                       {{ currentHiringManager.name }}
                       <span v-if="currentHiringManager.name"> - {{ currentHiringManager.email }}</span>
                       <span v-if="currentHiringManager.isHiringManager"> (Hiring Manager)</span>
                     </p>
                     <p v-else class="text-body-1 mb-0">-</p>

                     <!-- Hiring managers from the hierarchy chain who declined the invite -->
                     <div
                       v-for="(hm, index) in unavailableHiringManagers"
                       :key="hm.email || index"
                       class="my-5"
                     >
                       <p class="mb-1" role-type="subtitle-5">{{ hm.roleLabel }}</p>
                       <div class="d-flex align-center justify-space-between">
                         <p class="text-body-1 mb-0" role-type="subtitle-6">
                           {{ hm.name }}
                           <span v-if="hm.name"> - {{ hm.email }}</span>
                         </p>
                         <v-chip small class="hm-unavailable-chip ml-2">Unavailable</v-chip>
                       </div>
                     </div>
                   </template>

                     <div class="my-2">
                        <p role-type="subtitle-5" >Interviewer's HRIS Unique role</p>
                       <ul class="mt-1" role-type="body-4-gray">
                         <li v-for="(role, index) in hrisRoundWise" :key="index">{{ role }}</li>
                       </ul>
                      </div>
                    <p class="text-body-2 mb-3">Interviewer's email ID</p>
                    <v-autocomplete
                      v-model="emails"
                      :items="availableEmailsPage"
                      :loading="loadingInterviewers"
                      :search-input.sync="tag"
                      multiple
                      outlined
                      dense
                      hide-details
                      :hide-no-data="loadingInterviewers"
                      chips
                      class="assign-hiring-autocomplete mb-3"
                      item-value="email"
                      item-text="email"
                      :filter="customFilter"
                      @change="InterviewerAdded()"
                      @focus="onAutocompleteInteraction('page')"
                      @update:menu="onMenuToggle($event)"
                      label="Interviewer Email"
                      placeholder="Select"
                      clearable
                      rounded
                      :error="isInvalidEmailDomain"
                      no-data-text="No matching records found"
                      :menu.sync="menu"
                      append-icon="mdi-chevron-down"
                      :menu-props="{ contentClass: 'assign-hiring-menu', offsetY: true }"
                    >
                      <!-- Selected Chips -->
                      <template v-slot:selection="{ item, index }">
                        <v-chip
                          v-if="index < 1"
                          :key="index"
                          close
                          @click:close="removeTag(index)"
                          class="ma-2 blue--text email-chip n-overflow-hidden"
                        >
                          <template v-if="!getInterviewEmailSlot(index)">
                            <v-icon color="red">mdi-file-account-outline</v-icon>
                            <span class="red--text fit-content h-fit-content ma-4 tooltip">
                              {{ item.email }}
                              <span class="tooltiptext">
                                {{ `Another interview is already scheduled with ${item.name || item.email} during this time slot. Please choose a different time` }}
                              </span>
                            </span>
                          </template>
                          <template v-else>
                            {{ item.name }} - {{ item.email }}{{ item.isHiringManager ? ' (Hiring Manager)' : '' }}
                          </template>
                        </v-chip>

                        <v-tooltip v-else-if="index === 1" bottom content-class="email-overflow-tooltip" style="z-index: 999">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip v-bind="attrs" v-on="on" class="ma-2 blue--text email-chip n-overflow-hidden">
                              +{{ emails.length - 1 }}
                            </v-chip>
                          </template>
                          <div class="d-flex flex-column gap-2">
                            <div v-for="(interviewer, index) in overflowingInterviewerEmails" :key="index">
                              {{ interviewer }}
                            </div>
                          </div>
                        </v-tooltip>
                      </template>

                      <!-- Dropdown Items -->
                      <template v-slot:item="{ item, attrs, on }">
                        <!-- Render group header separately -->
                        <v-subheader v-if="item.header">
                          {{ item.hrisUniqueRole }}
                        </v-subheader>
                        
                        <!-- Render actual items -->
                        <v-list-item
                          v-else
                          v-bind="attrs"
                          v-on="on"
                          :class="`autocomplete-item-${getItemIndex(item)}`"
                          :data-index="getItemIndex(item)"
                        >
                          <template v-slot:default="{ active }">
                            <v-list-item-action>
                              <v-checkbox
                                :input-value="active"
                                color="primary"
                              />
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title class="text-body-2">
                                 {{ item.name }}
                                <span v-if="item.name"> - {{ item.email }}</span> <span v-if="item.isHiringManager"> (Hiring Manager)</span>
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <div v-if="isInvalidEmailDomain" class="invalid-message">
                      {{ "Please enter a valid interviewer’s email ID" }}
                    </div>
                    <!-- Pre-hierarchy hiring manager picker. Selecting a manager here is
                         mandatory to schedule (see hasInterviewerAndHiringManager); in the
                         edit flow the saved manager is preselected and every other option
                         is disabled, so it cannot be changed. -->
                  <v-autocomplete
                        v-if="!isHiringManagerHierarchyEnabled"
                        v-model="assignHiringManagerEmails"
                        :items="availableEmailsDialog"
                        :loading="loadingHiringManagers"
                        :search-input.sync="dialogTag"
                        multiple
                        return-object
                        outlined
                        dense
                        hide-details
                        :hide-no-data="loadingHiringManagers"
                        class="assign-hiring-autocomplete mt-6 mb-3 flex-grow-1"
                        item-text="email"
                        item-value="email"
                        :filter="customFilter"
                        @change="assignHiringManagerAdded()"
                        @focus="onAutocompleteInteraction('dialog')"
                        @update:menu="dialogMenu = $event"
                        label="Hiring Manager"
                        placeholder="Select"
                        clearable
                        rounded
                        no-data-text="No matching records found"
                        :menu.sync="dialogMenu"
                        append-icon="mdi-chevron-down"
                        :menu-props="{ contentClass: 'assign-hiring-menu', offsetY: true }"
                      >
                            <!-- Selected Value -->
                            <template v-slot:selection="{ item, index }">
                              <span
                                :key="index"
                                class="assign-hiring-selection d-flex align-center"
                              >
                                <template v-if="!getAssignHiringManagerEmailSlot(index)">
                                  <v-icon color="red" small>mdi-file-account-outline</v-icon>
                                  <span class="red--text fit-content h-fit-content ml-2 tooltip">
                                    {{ item.email }}
                                    <span class="tooltiptext">
                                      {{ `Another interview is already scheduled with ${item.name || item.email} during this time slot. Please choose a different time` }}
                                    </span>
                                  </span>
                                </template>
                                <template v-else>
                                  {{ item.email }}
                                </template>
                              </span>
                            </template>

                            <!-- Dropdown Items -->
                            <template v-slot:item="{ item, attrs, on }">
                              <!-- Render group header separately -->
                              <v-subheader v-if="item.header">
                                {{ item.hrisUniqueRole }}
                              </v-subheader>

                              <!-- Render actual items -->
                              <v-list-item
                                v-else
                                v-bind="attrs"
                                v-on="on"
                                :class="`autocomplete-item-${getItemIndex(item)}`"
                                :data-index="getItemIndex(item)"
                                :disabled="assignHiringManagerEmails.length >= 1 && !assignHiringManagerEmails.some(e => e.email === item.email)"
                              >
                                <template v-slot:default="{ active }">
                                  <v-list-item-action>
                                    <v-checkbox
                                      :input-value="active"
                                      color="primary"
                                    />
                                  </v-list-item-action>

                                  <v-list-item-content>
                                    <v-list-item-title class="text-body-2">
                                      {{ item.name }}
                                      <span v-if="item.name"> - {{ item.email }}</span> <span v-if="item.isHiringManager"> (Hiring Manager)</span>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </v-list-item>
                            </template>
                  </v-autocomplete>
                    <div class="mt-8" v-if="showExistingUsers.length">
                      <div class="rounded-list-bg text-body-1 mb-2">
                        <v-row>
                          <v-col cols="7" class="pl-6">Name</v-col>
                          <v-col cols="3">Response</v-col >
                          <v-col cols="2">Actions</v-col>
                        </v-row>
                      </div>
                      <v-row v-for="item  in showExistingUsers">
                        <v-col cols="7" class="text-body-2  pl-6" :class="item.hasOwnProperty('isSlotAvalable') && !item?.isSlotAvalable && hasDateTimeChanged && !checkSlotCallLoader ? 'slot-error' : ''" >
                          <div class="interviewer-name-cell d-flex justify-start">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span class="interviewer-name-text" v-bind="attrs" v-on="on">
                                  {{ item.interviewerName }} - {{item.interviewerEmail}}
                                </span>
                              </template>
                              <span>{{ item.interviewerName }} - {{item.interviewerEmail}}</span>
                            </v-tooltip>
                            <v-tooltip bottom :disabled="!item.delegatedByName">
                              <template #activator="{ on, attrs }">
                                <v-icon
                                  :disabled="!item.delegatedByName"
                                  class="interviewer-info-icon"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Delegated By {{ item.delegatedByName }}</span>
                            </v-tooltip>
                          </div>
                        </v-col>
                        <v-col cols="3" > <v-chip class="text-body-2" :class="statusChipColorMap.get(item.status?.toLowerCase())">
                       <span class="text-body-2"> {{ statusMappingHR.get(item.status?.toLowerCase()) }}</span>
                    </v-chip></v-col ><v-col cols="2" class="text-center d-flex align-center"> <v-icon @click="deleteConfirmation(item.interviewerEmail)" :disabled="isInterviewerDeleteDisabled(item)">mdi-trash-can-outline</v-icon> </v-col>
                      </v-row>
                    </div>
                    <div>
                       <p class="text-body-2 slot-error mt-4 d-flex align-center mt-6" v-if="hasDateTimeChanged && BusySlotNames.emails.length"> <v-icon class="slot-error pr-1">mdi-information-outline</v-icon> {{ BusySlotNames.text }} </p>
                       <p class="text-body-2 slot-error mt-4 d-flex align-center mt-6" v-if="!hasDateTimeChanged && BusySlotNames.emails.length"> <v-icon class="slot-error pr-1">mdi-information-outline</v-icon> {{ BusySlotNames.text }} </p>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="6" class="pt-0 pr-0">
              <v-form ref="form" class="overflow-hidden" lazy-validation>
                <div class="side-container">
                  <p role-type="body-3" class="font-weight-bold mb-5">Candidate Details</p>
                <v-row class="pa-0 px-4">Total Experience</v-row>
                <v-row
                  ><v-col class="pb-0 py-1">
                  <v-autocomplete
                  @change="handleExperienceYears"
                  hide-details="auto"
                  outlined
                  flat
                  solo
                  label="Years"
                  :items="experienceYearsOptions"
                  v-model="candidateDetails.totalExperience.years"
                  class="mt-1 rounded-xl ma-0 mt-0 mb-3"
                  required>
                  </v-autocomplete>
                  </v-col
                  ><v-col class="pb-0 pt-1">
                  <v-autocomplete
                  :disabled="candidateDetails.totalExperience.years === '10+ Years'"
                  @change="revalidateRelevantYears"
                  hide-details="auto"
                  outlined
                  flat
                  solo
                  label="Months"
                  :items="experienceMonthsOptions"
                  v-model="candidateDetails.totalExperience.months"
                  class="mt-1 rounded-xl ma-0 mb-3"
                  required>
                  </v-autocomplete>
                    </v-col
                ></v-row>
                <v-row class="pa-0 px-4 mt-2">Relevant Experience</v-row>
                <v-row
                  ><v-col class="pb-0 pt-1">
                    <v-autocomplete
                    ref="relevantYears"
                    hide-details="auto"
                    @change="handleExperienceYears"
                    outlined
                    flat
                    solo
                    label="Years"
                    :items="experienceYearsOptions"
                    v-model="candidateDetails.relevantExperience.years"
                    :rules="[() => checkExperience || 'Relevant experience cannot be more than the Total Experience']"
                    class="mt-1 rounded-xl ma-0 mt-0 mb-3"
                    required>
                    </v-autocomplete>
                    </v-col
                  ><v-col class="pb-0 pt-1">
                   <v-autocomplete
                  ref="relevantMonths"
                  :disabled="candidateDetails.relevantExperience.years === '10+ Years'"
                  hide-details="auto"
                  outlined
                  flat
                  solo
                  label="Months"
                  :items="experienceMonthsOptions"
                  v-model="candidateDetails.relevantExperience.months"
                  :rules="[() => checkExperience || 'Relevant experience cannot be more than the Total Experience']"
                  class="mt-1 rounded-xl ma-0 mb-3"
                  required>
                  </v-autocomplete> </v-col
                ></v-row>
                <v-row
                  ><v-col class="py-1">
                    <v-text-field
                      outlined
                      class="rounded-xl pt-1"
                      label="Current CTC (Annual CTC in Lakhs)"
                      text
                      type="text"
                      v-model="candidateDetails.currentCTC"
                      @input="val => formatCTC(val, 'currentCTC')"
                    ></v-text-field></v-col
                  ><v-col class="py-1"
                    ><v-text-field
                      outlined
                      label="Expected CTC (CTC in Lakhs)"
                      class="rounded-xl pt-1"
                      text
                      type="text"
                      v-model="candidateDetails.expectedCTC"
                      @input="val => formatCTC(val, 'expectedCTC')"
                    ></v-text-field> </v-col
                ></v-row>
                <v-row
                  ><v-col class="py-1">
                    <v-text-field
                      @input="restrictToWholeNumber($event)"
                      outlined
                      label="Notice Period (in days)"
                      class="rounded-xl pt-1"
                      v-model.lazy="candidateDetails.noticePeriod"
                      type="text"
                      text
                    ></v-text-field></v-col
                  ><v-col></v-col
                ></v-row>
              </div>
              </v-form>

            </v-col>
          </v-row>
        </v-container>
      </section>
      <div>
        <div
          width="100%"
          class="d-flex sticky-bottom mt-4 flex-row justify-end py-2"
        >
          <v-btn
            width="125px"
            height="48px"
            rounded
            outlined
            class="btn outline-btn mr-4 pa-4"
            @click="goBack"
            >Cancel</v-btn
          >
          <v-btn
            v-if="showStep1"
            width="300px"
            :disabled="!hasCompleteDateTimeSelection  || !isModify || !requiresApprovalFlow || !hasInterviewerAndHiringManager || unavailableInterviewers.length > 0"
            :loading="approvalLoading"
            @click="saveInputs"
            class="btn tertiary-btn pa-4 mr-2"
            >Send for Approval & {{
             emailAnddateChange
            }}</v-btn
          >
          <v-btn
            v-if="showStep1"
            width="125px"
            :disabled="
      !userData.teachingInterests.schools ||
      !isModify ||
      !hasCompleteDateTimeSelection ||
      requiresApprovalFlow
            "
            height="48px"
            :loading="loading"
            rounded
            @click="saveInputs"
            class="btn tertiary-btn pa-4 mr-2"
            >{{
             emailAnddateChange
            }}</v-btn
          >
          <v-btn
            v-if="showStep2 && !showStep1"
            width="125px"
            height="48px"
            :loading="finalSubmitProgress"
            rounded
            :disabled="canFinalSubmit"
            @click="candidateInterviewAction"
            class="btn tertiary-btn pa-4 mr-2"
            >Submit</v-btn
          >
        </div>
      </div>
    </div>
    <v-dialog v-if="showSuccessDialog" v-model="showSuccessDialog">
      <v-card class="interview-schedule--popup pa-6">
        <div class="d-flex align-center flex-column">
            <img
            class="cursor"
            width="96px"
            height="96px"
            src="../assets/success.svg"
          />
          <p class="interview-popup--text">
            <span v-if="interviewDecision">
              Decision Submitted
            </span>
            <span v-else>
              Interview
              {{ (round > 1) ? `Round ${round}` : '' }}
              {{ hasDateTimeChanged && userData.isResuduleFun ? 'Rescheduled' :  !userData.isResuduleFun ? 'Scheduled' : 'Updated Successfully' }}
            </span>
          </p>
          
          <p ><v-btn class="btn primary-btn" @click="goBack">Ok</v-btn></p>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-if="deleteInterviewerConfimationDialog" v-model="deleteInterviewerConfimationDialog" >
      <v-card class="delete-interview-pop pa-6">
        <div class="d-flex  flex-column">
           
          <p class="text-h6">
              Delete
          </p>
          <p class="text-body-2 pa-2">If an interviewer is removed, another may be added. Would you like to remove an interviewer from the list?</p>
           <p class="text-body-2 ml-1 mt-2">Comment<span class="red--text">*</span></p>
            <ckeditor :config="editorConfigDelete" v-model="deletecomment" class="m-ckeditor" 
            @ready="ondeleteEditorReady" >
          </ckeditor>
          <p class="d-flex justify-end mt-4">   <v-btn
            width="125px"
            height="48px"
            rounded
            outlined
            class="btn outline-btn mr-4 pa-4"
            @click="closeDeleteConfirmationDialog()"
            >Cancel</v-btn><v-btn class="btn primary-btn" :disabled="!deletecomment" @click="removeExistingEmail(deleteIndex)">Delete</v-btn></p>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-if="rescheduleConfimation" v-model="rescheduleConfimation" >
      <v-card class="delete-interview-pop pa-6">
        <div class="d-flex  flex-column">
           
          <p role-type="body-3">
              Reschedule Interview Confirmation
          </p>
          <p class="text-subtitle-1 pt-3">Rescheduling this interview will reset the availability of all interviewers and send new invitation emails.
            All selected interviewers will need to confirm their availability again</p>
       
          <p class="d-flex justify-end mt-5">   <v-btn
            width="125px"
            height="48px"
            rounded
            outlined
            class="btn outline-btn mr-4 pa-4"
            @click="rescheduleConfimation = false"
            >Cancel</v-btn><v-btn class="btn primary-btn" :loading="rescheduleLoader"  @click="rescheduleInterviewAfterConsent">Confirm & Reschedule</v-btn></p>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-if="hiringManagerUnavailableDialog" v-model="hiringManagerUnavailableDialog" >
      <v-card class="delete-interview-pop pa-6">
        <div class="d-flex  flex-column">

          <p role-type="body-3">
              Confirmation
          </p>
          <p class="text-subtitle-1 pt-3">The selected Hiring Manager, {{ unavailableHiringManager?.name }}, is unavailable
            to conduct the interview at the chosen time. Do you still want to proceed with scheduling the interview?</p>

          <p class="d-flex justify-end mt-5">   <v-btn
            width="125px"
            height="48px"
            rounded
            outlined
            class="btn outline-btn mr-4 pa-4"
            @click="hiringManagerUnavailableDialog = false"
            >Cancel</v-btn><v-btn class="btn primary-btn" @click="proceedHiringManagerUnavailable">Proceed</v-btn></p>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-if="deleteSuccessFullDialog" v-model="deleteSuccessFullDialog" >
      <v-card class="interview-schedule--popup pa-6">
        <div class="d-flex align-center flex-column">
            <img
            class="cursor"
            width="96px"
            height="96px"
            src="../assets/delete-icon.svg"
          />
          <p class="text-subtitle-1">
           
            <span >
             Deleted Successfully
            </span>
          </p>
          <p class="mt-4"><v-btn class="btn primary-btn px-16" @click="deleteSuccessFullDialog = false">Ok</v-btn></p>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-if="requestSlotDialog" v-model="requestSlotDialog" fullscreen hide-overlay transition="dialog-bottom-transition" content-class="request-slot-dialog">
      <v-card tile class="d-flex flex-column request-slot-card" height="100vh">
        <div class="pa-6 pb-4 request-slot-header">
          <p class="text-h6 mb-0">Request Slot</p>
        </div>

        <div class="px-6 pb-6 flex-grow-1 request-slot-body">
          <v-row no-gutters class="request-slot-row">
            <v-col cols="12" md="7" class="pr-md-3 request-slot-col">
              <v-card elevation="2" class="rounded-lg pa-4 mb-4 mb-md-0 request-slot-inner-card">
                <div class="mb-3">    
                  <v-btn class="btn outline-btn mr-3" @click="goToday">
                    <v-icon left small>mdi-map-marker</v-icon>
                    Today
                  </v-btn>
                </div>

                <div class="d-flex justify-space-between align-center mb-4">
                  <p class="text-h6 text-uppercase font-weight-bold mb-0">
                    {{ monthLabel }}
                  </p>
                  <div>
                    <v-btn icon class="mr-2" width="40" height="40" @click="prevMonth" :disabled="isPrevRequestMonthDisabled">
                      <img src="../assets/svg/chevron-left-circle-outline.svg" width="40" height="40" alt="Previous month" :class="{ 'rs-month-nav--disabled': isPrevRequestMonthDisabled }" />
                    </v-btn>
                    <v-btn icon width="40" height="40" @click="nextMonth" :disabled="isNextRequestMonthDisabled">
                      <img src="../assets/svg/chevron-right-circle-outline.svg" width="40" height="40" alt="Next month" :class="{ 'rs-month-nav--disabled': isNextRequestMonthDisabled }" />
                    </v-btn>
                  </div>
                </div>

                <div class="rs-calendar"> 
                 <div class="rs-calendar-header">
                  <div
                      v-for="day in ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']"
                      :key="day"
                      class="rs-calendar-header-cell text-subtitle-2"
                    >
                      {{ day }}
                    </div>
                  </div>
                  <div class="rs-calendar-body">
                    <div
                      v-for="day in flatCalendarDays"
                      :key="day.iso"
                      class="rs-calendar-cell cursor"
                      :class="{
                        'rs-calendar-cell--selected': isSelectedDate(day),
                        'rs-calendar-cell--today': day.isToday,
                        'rs-calendar-cell--out': !day.inCurrentMonth,
                        'rs-calendar-cell--disabled': isPastRequestSlotDate(day) || day.isSunday || isAfterMaxRequestSlotMonth(day.date),
                      }"
                      @click="selectDate(day)"
                    >
                      <span class="rs-calendar-day text-body-2">{{ pad(day.day) }}</span>
                      <div
                        v-if="day.isHoliday"
                        class="rs-calendar-holiday"
                      >
                        Holiday
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="5" class="pl-md-3 request-slot-col">
              <v-card elevation="2" class="rounded-lg pa-4 request-slot-inner-card">
                <p class="text-subtitle-1 font-weight-bold mb-1">Select Slot</p>
                <p class="text-body-2 grey--text text--darken-1 mb-4">{{ formattedSelectedDate }}</p>

                <div class="mb-4 request-slot-interviewers" v-if="requestSlotInterviewers.length">
                  <p class="text-subtitle-2 mb-2">Interviewers</p>
                  <div class="text-body-2 d-flex align-center flex-wrap">
                    <span
                      :class="!checkSlotCallLoader && requestSlotUnavailableInterviewers.some(u => u.email === requestSlotInterviewers[0].email) ? 'slot-error' : ''"
                    >
                      {{ requestSlotInterviewers[0].name }} - {{ requestSlotInterviewers[0].email }}{{ requestSlotInterviewers[0].isHiringManager ? ' (Hiring Manager)' : '' }}
                    </span>
                    <template v-if="requestSlotInterviewers.length > 1">
                      <span>,&nbsp;</span>
                      <v-tooltip bottom content-class="email-overflow-tooltip" style="z-index: 999">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="blue--text cursor text-no-wrap">+{{ requestSlotInterviewers.length - 1 }}</span>
                        </template>
                        <div class="d-flex flex-column gap-2">
                          <div
                            v-for="(interviewer, idx) in requestSlotInterviewers.slice(1)"
                            :key="interviewer.email || idx"
                            :class="!checkSlotCallLoader && requestSlotUnavailableInterviewers.some(u => u.email === interviewer.email) ? 'slot-error' : ''"
                          >
                            {{ interviewer.name }} - {{ interviewer.email }}{{ interviewer.isHiringManager ? ' (Hiring Manager)' : '' }}
                          </div>
                        </div>
                      </v-tooltip>
                    </template>
                  </div>
                  <p
                    class="text-body-2 slot-error mt-3 mb-0 d-flex align-start"
                    v-if="!checkSlotCallLoader && requestSlotUnavailableInterviewers.length"
                  >
                    <v-icon class="slot-error pr-1" small>mdi-information-outline</v-icon>
                    {{ requestSlotBusyText }}
                  </p>
                </div>

                <div class="slot-accordion-scroll">
                <v-card outlined class="rounded-lg mb-3 slot-accordion-card">
                  <v-expansion-panels
                    accordion
                    flat
                    :value="expandedSlotPanel === 'morning' ? 0 : null"
                    @change="onRequestSlotPanelChange('morning', $event)"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header class="text-subtitle-2">Morning</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <p class="text-caption grey--text text--darken-1 mb-3">
                          <span help-text-required></span>
                        </p>
                        <v-item-group class="d-flex flex-wrap w-100 gap-10 schedule-card" mandatory>
                          <v-item
                            v-for="slot in morningSlots"
                            class="mb-2 mr-2 slot-item"
                            v-slot="{ toggle }"
                            :key="slot.key"
                          >
                            <v-card
                              @click="selectRequestSlot(slot)"
                              :class="
                                currentTimeSlotIndex?.toString() === slot.index?.toString() && !isRequestSlotDisabled(slot)
                                  ? 'SI-time-card-active'
                                  : 'SI-time-card'
                              "
                              class="rounded-lg text-center align-center d-flex justify-center py-2 px-3"
                              :disabled="isRequestSlotDisabled(slot)"
                              :ripple="!isRequestSlotDisabled(slot)"
                              :data-disabled="isRequestSlotDisabled(slot)"
                            >
                              {{ slot.start }} - {{ slot.end }}
                            </v-card>
                          </v-item>
                        </v-item-group>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card>

                <v-card outlined class="rounded-lg mb-3 slot-accordion-card">
                  <v-expansion-panels
                    accordion
                    flat
                    :value="expandedSlotPanel === 'afternoon' ? 0 : null"
                    @change="onRequestSlotPanelChange('afternoon', $event)"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header class="text-subtitle-2">Afternoon</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <p class="text-caption grey--text text--darken-1 mb-3">
                            <span help-text-required></span>
                        </p>
                        <v-item-group class="d-flex flex-wrap w-100 gap-10 schedule-card" mandatory>
                          <v-item
                            v-for="slot in afternoonSlots"
                            class="mb-2 mr-2 slot-item"
                            v-slot="{ toggle }"
                            :key="slot.key"
                          >
                            <v-card
                              @click="selectRequestSlot(slot)"
                              :class="
                                currentTimeSlotIndex?.toString() === slot.index?.toString() && !isRequestSlotDisabled(slot)
                                  ? 'SI-time-card-active'
                                  : 'SI-time-card'
                              "
                              class="rounded-lg text-center align-center d-flex justify-center py-2 px-3"
                              :disabled="isRequestSlotDisabled(slot)"
                              :ripple="!isRequestSlotDisabled(slot)"
                              :data-disabled="isRequestSlotDisabled(slot)"
                            >
                              {{ slot.start }} - {{ slot.end }}
                            </v-card>
                          </v-item>
                        </v-item-group>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card>

                <v-card outlined class="rounded-lg mb-3 slot-accordion-card">
                  <v-expansion-panels
                    accordion
                    flat
                    :value="expandedSlotPanel === 'evening' ? 0 : null"
                    @change="onRequestSlotPanelChange('evening', $event)"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header class="text-subtitle-2">Evening</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <p class="text-caption grey--text text--darken-1 mb-3">
                          
                            <span help-text-required></span>
                        </p>
                        <v-item-group class="d-flex flex-wrap w-100 gap-10 schedule-card" mandatory>
                          <v-item
                            v-for="slot in eveningSlots"
                            class="mb-2 mr-2 slot-item"
                            v-slot="{ toggle }"
                            :key="slot.key"
                          >
                            <v-card
                              @click="selectRequestSlot(slot)"
                              :class="
                                currentTimeSlotIndex?.toString() === slot.index?.toString() && !isRequestSlotDisabled(slot)
                                  ? 'SI-time-card-active'
                                  : 'SI-time-card'
                              "
                              class="rounded-lg text-center align-center d-flex justify-center py-2 px-3"
                              :disabled="isRequestSlotDisabled(slot)"
                              :ripple="!isRequestSlotDisabled(slot)"
                              :data-disabled="isRequestSlotDisabled(slot)"
                            >
                              {{ slot.start }} - {{ slot.end }}
                            </v-card>
                          </v-item>
                        </v-item-group>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <v-card flat tile class="request-slot-footer pa-4 d-flex justify-space-between align-center">
          <span class="text-body-2 grey--text text--darken-1">   <span help-text-required></span></span>
          <div class="d-flex">
            <v-btn class="btn outline-btn mr-3" @click="cancelRequestSlotDialog">
              Cancel
            </v-btn>
            <v-btn
            depressed
            :disabled="!canProceedRequestSlot" @click="onProceedRequestSlot"
            rounded          
             class="btn tertiary-btn"
          >
            Proceed
          </v-btn>
          </div>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CampaignController from "@/controllers/CampaignController";
import AuthService from "../services/AuthService";
import { getDownloadURL, uploadBytes, ref as storageRef } from "firebase/storage";
import { db, storage } from "../firebase";
import UsersController from "@/controllers/UsersController";
import UserNavMenu from "@/components/UserNavMenu.vue";
import { debounce } from "lodash";
import { Carousel, Slide } from 'vue-carousel';

export default {
  components:{
      UserNavMenu,
      Carousel,
      Slide
  },
  name: "scheduleInterviewRounds",
  computed: {
    // Master switch for the hiring-manager hierarchy flow. While it is off the
    // page keeps the pre-hierarchy behaviour: the manager is chosen manually
    // through the Hiring Manager autocomplete instead of being resolved from
    // (and displayed as) the HRIS hierarchy chain.
    isHiringManagerHierarchyEnabled(){
      return this.$featureFlags.isEnabled('hiring_manager_hierarchy');
    },
    shouldClearHMDraft(){
      const isFreshScheduleFlow = this.isSchedule || this.isNextRoundScheduleStarted;
      return isFreshScheduleFlow && !this.interviewScheduleCompleted;
    },
    currentHiringManager(){
      if(this.selectedHiringManagerEmail){
        return this.hiringManagersFromInterviewers.find(
          (hm) => hm.email === this.selectedHiringManagerEmail
        ) || this.assignHiringManagerEmails[0]
      }
      return this.assignHiringManagerEmails[0]
    },
    // The resolution-chain entry for the currently-assigned hiring manager, matched
    // by email so the level label and HRIS role always describe the same manager
    // shown for name/email. The chain is sourced per the schedule/edit rule via
    // effectiveHiringManagerChain: the live getHiringManagerDetails chain when
    // scheduling (first time / new round), the slot's saved interviewSlotDetails
    // chain when editing.
    currentHiringManagerChainEntry(){
      const manager = this.currentHiringManager;
      if (!manager || !manager.email) return null;
      const chain = this.effectiveHiringManagerChain || [];
      const idx = chain.findIndex((c) => c.assignedEmail === manager.email);
      return idx > -1 ? { ...chain[idx], index: idx } : null;
    },
    // Level label (Primary / Secondary / Tertiary) of the currently-assigned hiring
    // manager. Returns '' for Primary — or when the level can't be determined — so
    // the panel shows a plain "Hiring Manager"; Secondary/Tertiary prefix the two HM
    // labels once the primary (and secondary) have declined and the active HM has
    // moved down the chain.
    currentHiringManagerRoleLabel(){
      const roleLabels = ['Primary', 'Secondary', 'Tertiary'];
      const entry = this.currentHiringManagerChainEntry;
      let label = entry ? (roleLabels[entry.index] || entry.label) : '';

      // Fall back to the resolved level (schedule) or the saved slot level (edit).
      if (!label) {
        const level = this.isSchedule
          ? this.hiringManagerCurrentLevel
          : (this.oldHiringManager?.currentLevel ?? this.hiringManagerCurrentLevel);
        if (level != null) label = roleLabels[level - 1];
      }

      return label && label !== 'Primary' ? label : '';
    },
    currentHiringManagerHrisRole(){
      const entry = this.currentHiringManagerChainEntry;
      const manager = this.currentHiringManager;
      return (entry && entry.hrisUniqueRole)
        || (manager && (manager.hrisUniqueRole || manager.hiringManagerDesignation))
        || '';
    },
    // Chain of hiring managers used to derive the unavailable ones. In edit mode
    // the persisted chain from the booked slot (hiringManagerDetails.chain) is the
    // source of truth, since the live hierarchy from getHiringManagerEmail() may
    // have changed since the interview was scheduled. Falls back to the live chain
    // (schedule flow, or when the slot has no saved chain).
    effectiveHiringManagerChain(){
      if (!this.isSchedule) {
        const slotDetails =  this.userData?.interviewDetails?.interviewSlotDetails || [];
        const savedChain = slotDetails[(this.round || 1) - 1]?.hiringManagerDetails?.chain;
        if (Array.isArray(savedChain) && savedChain.length) {
          return savedChain;
        }
      }
      return this.hiringManagerChain || [];
    },
    // Hiring managers from the resolution chain who declined the invite
    // (status UNAVAILABLE). Chain position maps to Primary/Secondary/Tertiary.
    unavailableHiringManagers(){
      const roleLabels = ['Primary', 'Secondary', 'Tertiary'];
      return (this.effectiveHiringManagerChain || [])
        .map((item, index) => ({
          name: item.assignedName || '',
          email: item.assignedEmail || '',
          status: item.status,
          roleLabel: `${roleLabels[index] || item.label || 'Hiring'} Hiring Manager`,
        }))
        .filter((item) => String(item.status).toUpperCase() === 'UNAVAILABLE');
    },
    isHiringManagerChangeDisabled() {
      if (this.userData?.interviewFinalStatus?.status === "ROUND_ACCEPTED" && Number(this.userData?.round) !== Number(this.userData?.interviewFinalStatus?.round)) {
        return false;
      }

      const roundIndex = (this.round || 1) - 1;
      const emails = (this.userData?.interviewDetails?.allSlotDetails || this.userData?.interviewDetails?.interviewSlotDetails)?.[roundIndex]?.interviewerEmails || [];
      const feedbackForRound = this.userData?.interViewFeedback?.filter(fb => Number(fb.round) === Number(this.round)) || [];

      const totalInvited = emails.length;
      let requiredFeedback = 0;
      if(totalInvited >= 3) {
        requiredFeedback = totalInvited - 1;
      } else {
        requiredFeedback = totalInvited;
      }

      const feedbackReceived = emails.filter(email =>
        feedbackForRound?.some(fb => fb.interviewerEmail === email)
      ).length;

      return totalInvited > 0 && feedbackReceived >= requiredFeedback;
    },
    // Every interviewer in the panel — newly added (emailList) and already
    // assigned (existingInterviewers) — who is unavailable for the currently
    // selected slot. Single source of truth shared by the red "unavailable"
    // message (BusySlotNames) and the primary-action disable logic, so the
    // button state can never disagree with the message shown to the user.
    unavailableInterviewers(){
      // Availability only means something once a full date + time slot is chosen.
      // Until then, treat nobody as unavailable so a stale "unavailable" message
      // doesn't linger after the date is changed and the time cleared.
      if (!this.hasCompleteDateTimeSelection) return [];
      return [...this.emailList, ...this.existingInterviewers].filter((i)=> !i?.isSlotAvalable)
    },
    BusySlotNames(){
      let emails = this.unavailableInterviewers
      return {
        text: `${emails.map(n => n.name.split(' ')[0]).join(',')}  ${emails.length > 1 ? 'are' : 'is'} unavailable at the selected date and time. Kindly reschedule to a different slot or assign a different interviewer.`,
        emails
      }
    },
    showExistingUsers(){
      return this.existingInterviewers.filter(i => i.status !== 'DELEGATED')
    },
    deleteWindowClosed(){
      let slotDetails = this.userData?.interviewDetails?.allSlotDetails || this.userData?.interviewDetails?.interviewSlotDetails || []
         if (!Array.isArray(slotDetails) || slotDetails.length === 0) {
                return false
            }

            const curSlot = slotDetails[slotDetails.length - 1]
            const slotDate = curSlot?.slotDate
            const slotStart = curSlot?.timeSlotDetails?.slotStart

            if (!slotDate || !slotStart) {
                return false
            }

            const slotDateTime = `${slotDate} ${slotStart}`
            
            try {
                return this.getHoursLeftFromRange(slotDateTime) <= 6
            } catch (error) {
                return false
            }
    },
    canFinalSubmit(){
      if(this.userStatusCheckbox === "SEND_TO_HIRING_MANAGER") {
        return !(this.interviewRemark !== "" && this.selectedManager?.hiringManagerEmail);
      }
      else {
        return !(this.interviewRemark !== "" && this.userStatusCheckbox !== "");
      }
    },
    newRoundSchedule() {
      return this.userData?.interviewFinalStatus?.status === "ROUND_ACCEPTED" && Number(this.userData?.interviewFinalStatus?.round) === this?.userData?.round;
    },
    emailAnddateChange() {
      const hasEmailChanged = this.emails.length > 0;
      const hasEmailDeleted = this.oldEmails !== this.existingInterviewers.map(item => item.interviewerEmail).sort().join(',');
      this.hasDateTimeChanged = this.oldSlotId + this.oldSlotIndex !== this.currentSlotId + this.currentTimeSlotIndex;
      const allSlotAvaialble = !this.unavailableInterviewers.length
      const hiringManagerChanged = this.currentHiringManager?.email !== this.oldHiringManager?.hiringManagerEmail
      const isInterviewerExistInSlot = [...this.emails, ...this.existingInterviewers].length
      const isRescheduleMode = this.userData?.isResuduleFun;
      if (!isRescheduleMode) {
        this.isModify = allSlotAvaialble && this.assignHiringManagerEmails.length && isInterviewerExistInSlot;
        return 'Schedule';
      }
      // In reschedule mode, always return 'Reschedule'
      // Only set isModify to false if nothing changed
      const hasAnyChange = hasEmailChanged || hasEmailDeleted || this.hasDateTimeChanged || hiringManagerChanged || this.interviewModeChanged;
      this.isModify = hasAnyChange && allSlotAvaialble && this.assignHiringManagerEmails.length && isInterviewerExistInSlot
       return "Update"
      // return this.hasDateTimeChanged ?  'Reschedule' : 'Update';
    },
    getHiringManagerRemark() {
      if(this.interviewStatusHistory) {
        const roundfeedback = this.interviewStatusHistory[this.latestFeedbackRound]
        const data = roundfeedback.filter((fb) => fb.status === "NOTIFY_HR_TO_SCHEDULE_NEXT_ROUND" || fb.status === "ACCEPT_AND_SCHEDULE_NEXT_ROUND")[0] ?? null;
        return data;
      }
      else {
        return null
      }
    },
    isProduction() {
      const localStorageValue = localStorage.getItem('DISABLE_INTERVIEW_RESTRICTION');
      if (localStorageValue === 'false') {
        return true;
      }
      return process.env.VUE_APP_IS_PRODUCTION === "true";
    },
    checkExperience() {
      const totalExperience = this.convertToMonths(this.candidateDetails.totalExperience);
      const relevantExperience = this.convertToMonths(this.candidateDetails.relevantExperience);
      return totalExperience >= relevantExperience;
    },
    hiringManagersFromInterviewers(){
      let data = this.isSchedule  ? this.stateEmails :   [...this.stateEmails, ...this.existingInterviewers]
      return data.filter(i => i.isHiringManager).map((i)=>{
        if(i.interviewerEmail){
          i['email'] = i.interviewerEmail 
        }
        if(i.interviewerName){
          i['name'] = i.interviewerName
        }
        return i
      })
    },
    // True when a real time-slot index is chosen. currentTimeSlotIndex may be a
    // number (-1 = none, 0+ = a slot), a numeric string (Request Slot dialog), or
    // an empty string / array when cleared or reset — only a numeric value >= 0
    // counts as an actual selection (guards against "", [] and null coercing to a
    // match, e.g. `"" > -1` and `[] > -1` are both true).
    hasTimeSlotSelected() {
      const idx = this.currentTimeSlotIndex;
      const isNumericLike = typeof idx === 'number' || (typeof idx === 'string' && idx.trim() !== '');
      return isNumericLike && Number(idx) >= 0;
    },
    // "Any" selection — a date OR a time slot. Gates Clear Selection so the user can
    // clear whatever is currently picked.
    hasDateTimeSelection() {
      return !!this.currentSlotId || this.hasTimeSlotSelected;
    },
    // Both a date AND a time slot must be chosen before a slot can be booked or sent
    // for approval. A time slot can be clicked without first picking a date
    // (setCurrentTimeSlotIndex sets only the index), so the action buttons must
    // require completeness, not just "any" selection.
    hasCompleteDateTimeSelection() {
      return !!this.currentSlotId && this.hasTimeSlotSelected;
    },
    // True when the selected slot is one of the first 8 (index < 8), which are
    // directly bookable (no request-slot approval needed). Drives the Request
    // Slot button's disabled/label state.
    isDirectBookingWindow() {
      return Number(this.currentTimeSlotIndex) < 8;
    },
    // Label for the "Request / Edit Slot" button. Reads "Edit" whenever an
    // outside-3–5 slot (index > 7) is currently selected — this holds for both
    // first-time booking (spec §1 Case A) and edit mode (§2) — otherwise it
    // reads "Request".
    requestSlotButtonLabel() {
      return !this.isDirectBookingWindow && this.currentSlotId && this.currentTimeSlotIndex
        ? 'Edit'
        : 'Request';
    },
    // The "Request / Edit Slot" button is disabled ONLY while a direct 3–5 slot
    // (a chosen date + index 0–7) is actively selected. Once the selection is
    // cleared (no date / index -1) the button re-enables so the user can open
    // the request-slot dialog; when an outside slot (index > 7) is selected it
    // also stays enabled to allow editing that request.
    disableRequestSlotButton() {
      const idx = Number(this.currentTimeSlotIndex);
      return !!this.currentSlotId && idx >= 0 && idx < 8;
    },
    // Spec §2 Case B (PENDING): while editing a booking whose existing slot was
    // OUTSIDE the 3–5 window and whose request is still PENDING, the candidate
    // may only be re-requested into another outside slot. Selecting a 3–5
    // (direct) slot is blocked, so the entire direct-slot grid (dates + time
    // slots — all index ≤ 7) is disabled. Any other status (APPROVED/REJECTED)
    // or a first-time booking leaves the grid enabled.
    disableThreeToFiveSlots() {
      // First-time scheduling: once a slot has been picked from the Request
      // Slot dialog (approval flow pending), lock the direct 3–5 grid. Clear
      // Selection resets isRequestSlotSelection, which re-enables it.
      if (this.isSchedule && this.requiresApprovalFlow) {
        return true;
      }
      return (
        !this.isSchedule &&
        Number(this.oldSlotIndex) > 7 &&
        String(this.slotStatus).toUpperCase() === 'PENDING'
      );
    },
    interviewModeChanged() {
      return !!this.userData?.isResuduleFun
        && !!this.oldInterviewMode
        && this.interviewMode !== this.oldInterviewMode;
    },
    isEditingRequestedSlot() {
      return !!this.userData?.isResuduleFun && Number(this.oldSlotIndex) > 7;
    },
    requiresApprovalFlow() {
      if (this.isRequestSlotSelection) {
        return true;
      }
      return this.isEditingRequestedSlot && this.interviewModeChanged;
    },
    // At least one interviewer AND a hiring manager must be chosen. The direct
    // "Schedule" button enforces this through isModify; the "Send for Approval"
    // button reuses this so the same selections are mandatory there too.
    hasInterviewerAndHiringManager() {
      if(!this.isHiringManagerHierarchyEnabled){
        return true
      }
      const hasInterviewers = [...this.emails, ...this.existingInterviewers].length > 0;
      return hasInterviewers && this.assignHiringManagerEmails.length > 0;
    },
    // Date & time selection (the inline 3–5 slot grid AND the Request Slot
    // dialog) is locked until at least one interviewer is selected. In edit/
    // reschedule existingInterviewers is pre-populated, so selection stays open.
    hasSelectedInterviewers() {
      return this.emails.length > 0 || this.existingInterviewers.length > 0;
    },
    monthLabel(){
      const months = ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER'];
      return `${months[this.requestSlotCalendarDate.getMonth()]} ${this.requestSlotCalendarDate.getFullYear()}`;
    },
    // Upper bound for the Request Slot calendar: the user may book in the current
    // month plus the next two whole months only (counted by month, not by days).
    // e.g. if today is 31 Dec, the whole of Jan and Feb is selectable, but March
    // onwards is not. The Date constructor normalises the month rollover/year.
    maxRequestSlotMonth(){
      const today = new Date();
      return new Date(today.getFullYear(), today.getMonth() + 2, 1);
    },
    // Disables the "next month" arrow once the calendar reaches current month + 2
    // so the user cannot navigate past the last allowed month.
    isNextRequestMonthDisabled(){
      const shown = new Date(
        this.requestSlotCalendarDate.getFullYear(),
        this.requestSlotCalendarDate.getMonth(),
        1
      );
      return shown >= this.maxRequestSlotMonth;
    },
    // Disables the "previous month" arrow once the calendar is on the current
    // month, since past months hold no selectable dates.
    isPrevRequestMonthDisabled(){
      const today = new Date();
      const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      const shown = new Date(
        this.requestSlotCalendarDate.getFullYear(),
        this.requestSlotCalendarDate.getMonth(),
        1
      );
      return shown <= currentMonthStart;
    },
    // Whether the requested slot was rejected by the approver — drives the red text.
    isSlotRejected(){
      return String(this.slotStatus).toUpperCase() === 'REJECTED';
    },
    // A PENDING or REJECTED slot is not a live booking — the requested time is
    // either still waiting on the approver or was turned down, so nothing is
    // confirmed with the interviewers yet. Two things follow from that, and both
    // read this flag: removing an interviewer is persisted immediately through
    // deleteInterviewerFromSlot with no confirm-with-comment dialog (see
    // deleteConfirmation), and the usual guard rails on the delete action — the
    // interviewer's own accepted/declined response and the 6-hour cut-off —
    // don't apply, so the row stays removable (see isInterviewerDeleteDisabled).
    // An ACCEPTED slot is a real booking and keeps the normal comment flow.
    isSlotPendingOrRejected(){
      return ['PENDING', 'REJECTED'].includes(String(this.slotStatus).toUpperCase());
    },
    // Formats the requested slot (currentSlotId + currentTimeSlotIndex) for the
    // info block, e.g. "12:31 - 12:45, 23 Feb 2024".
    requestedSlotDateTime(){
      let start = '';
      let end = '';
      const requestSlot = this.getSelectedRequestSlot();
      if (requestSlot) {
        start = requestSlot.start;
        end = requestSlot.end;
      } else {
        const timeSlot = (this.currentTimeSlots || []).find(
          s => String(s.index) === String(this.currentTimeSlotIndex)
        );
        if (timeSlot) {
          start = timeSlot.slotStart;
          end = timeSlot.slotEnd;
        }
      }
      const timeRange = start && end ? `${start} - ${end}` : '';

      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      const date = this.parseRequestSlotDate(this.currentSlotId);
      const dateStr = date ? `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}` : '';

      if (timeRange && dateStr) return `${timeRange}, ${dateStr}`;
      return timeRange || dateStr || '-';
    },
    calendarWeeks(){
      const year = this.requestSlotCalendarDate.getFullYear();
      const month = this.requestSlotCalendarDate.getMonth();
      const firstDay = new Date(year, month, 1);
      const dayOfWeek = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;
      const lastDay = new Date(year, month + 1, 0);
      const totalCells = dayOfWeek + lastDay.getDate();
      const weeksNeeded = Math.ceil(totalCells / 7);
      const startDate = new Date(year, month, 1 - dayOfWeek);

      const weeks = [];
      const cur = new Date(startDate);
      const today = new Date();
      for (let w = 0; w < weeksNeeded; w++) {
        const week = [];
        for (let d = 0; d < 7; d++) {
          const date = new Date(cur);
          const isoDate = `${date.getFullYear()}-${this.pad(date.getMonth()+1)}-${this.pad(date.getDate())}`;
          const isSunday = date.getDay() === 0;
          const isManualHoliday = this.requestSlotHolidays.indexOf(isoDate) !== -1;
          week.push({
            date,
            iso: isoDate,
            day: date.getDate(),
            inCurrentMonth: date.getMonth() === month,
            isToday: this.isSameDay(date, today),
            isSunday,
            isHoliday: isSunday || isManualHoliday,
          });
          cur.setDate(cur.getDate() + 1);
        }
        weeks.push(week);
      }
      return weeks;
    },
    flatCalendarDays(){
      return this.calendarWeeks.reduce((acc, week) => acc.concat(week), []);
    },
    formattedSelectedDate(){
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      const d = this.getRequestSlotSelectedDate();
      return `${this.pad(d.getDate())} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    morningSlots(){
      return this.generateSlots(7*60 + 1, 12*60, 8);
    },
    afternoonSlots(){
      return this.generateSlots(12*60 + 1, 16*60, 28);
    },
    eveningSlots(){
      return this.generateSlots(16*60 + 1, 21*60, 44);
    },
    canProceedRequestSlot(){
      const selectedSlot = this.getSelectedRequestSlot();
      if (!selectedSlot || this.isRequestSlotDisabled(selectedSlot)) {
        return false;
      }
      // Keep Proceed disabled while the availability check is running, or when
      // any interviewer is unavailable for the selected date & time.
      if (this.checkSlotCallLoader) {
        return false;
      }
      return !this.requestSlotUnavailableInterviewers.length;
    },
    // Unified interviewer list (newly added + already assigned) rendered inside
    // the Request Slot dialog, annotated with availability for the selected slot.
    requestSlotInterviewers(){
      const added = (this.stateEmails || []).filter(Boolean).map(item => {
        const checked = this.emailList.find(e => e.email === item.email);
        return {
          name: item.name,
          email: item.email,
          isHiringManager: !!item.isHiringManager,
          hasSlotInfo: !!checked,
          isSlotAvalable: checked ? checked.isSlotAvalable : true,
        };
      });
      const existing = this.showExistingUsers.map(item => ({
        name: item.interviewerName,
        email: item.interviewerEmail,
        isHiringManager: !!item.isHiringManager,
        hasSlotInfo: Object.prototype.hasOwnProperty.call(item, 'isSlotAvalable'),
        isSlotAvalable: item.isSlotAvalable !== false,
      }));
      return [...added, ...existing];
    },
    unavailableHiringManager(){
      return this.requestSlotInterviewers.find(
        i => i.isHiringManager && i.hasSlotInfo && i.isSlotAvalable === false
      ) || null;
    },
    // Interviewers whose slot is unavailable for the currently selected slot.
    // Empty until a slot is selected so stale results never block Proceed.
    requestSlotUnavailableInterviewers(){
      if (!this.getSelectedRequestSlot()) {
        return [];
      }
      return this.requestSlotInterviewers.filter(i => i.hasSlotInfo && !i.isSlotAvalable);
    },
    requestSlotBusyText(){
      const names = this.requestSlotUnavailableInterviewers.map(
        i => i.name || i.email || ''
      );
      return `${names.join(', ')} is unavailable at the selected date and time. Kindly reschedule to a different slot or assign a different interviewer.`;
    },
    overflowingInterviewerEmails(){
      return this.emails.slice(1).map(email => {
        const interviewer = this.availableEmailsPage.find(item => item.email === email);
        if (!interviewer) return email;
        return `${interviewer.name} - ${interviewer.email}${interviewer.isHiringManager ? ' (Hiring Manager)' : ''}`;
      });
    },
  },
  watch: {
    tag(newValue, oldVal  ) {
      if(oldVal == null && newValue == ''){
       return 
      }
      if(oldVal == '' && newValue == ''){
        return 
      }
      if(this.tag !== null || this.tag !== undefined){
        this.debouncedTagChange()
      }
    },
    dialogTag(newValue, oldVal) {
      if(oldVal == null && newValue == ''){
        return 
      }
      if(oldVal == '' && newValue == ''){
        return 
      }
      if(this.dialogTag !== null || this.dialogTag !== undefined){
        this.debouncedDialogTagChange()
      }
    },
    requestSlotDialog(newValue) {
      if (newValue) {
        this.syncRequestSlotDialogState();
      }
    },
    selectedHiringManagerEmail(newValue) {
      if(!newValue){
        this.assignHiringManagerEmails = []
        return
      }
      const match = this.hiringManagersFromInterviewers.find((hm) => hm.email === newValue)
      if(match){
        this.assignHiringManagerEmails = [match]
      }
    },
    showSuccessDialog(newValue) {
      if (newValue) {
        this.interviewScheduleCompleted = true
      }
    }
  },
  data() {
    return {
          slotStatus: '',
          approverDetails: null,
          assignHiringManagerDialog: false,
          deleteIndex: -1,
          deleteInterviewerConfimationDialog: false,
          // Email currently being removed through the direct (no-prompt) delete
          // API — blocks a second delete while the request is in flight.
          deletingInterviewerEmail: '',
          rescheduleConfimation: false,
          rescheduleLoader: false,
          hiringManagerUnavailableDialog: false,
          deleteSuccessFullDialog: false,
          statusMappingHR: new Map([['invited', 'Invite Sent'],
          ['accepted', 'Confirmed'],
          ['declined', 'Rejected'],
          ['inprogress', 'Accepted'],
          ['completed', 'Accepted'],
          ['delegated', 'Delegated'],
          ['na', 'NA']
        ]),
          statusChipColorMap: new Map([
              ['invited', 'blue-chip'],
                ['completed', 'green-chip'],
                ['delegated', 'orange-chip'],
                ['accepted', 'green-chip'],
                ['declined', 'red-chip'],
                ['inprogress','magenta-chip'],
                ['na', 'blue-chip']
          ]),
      emailRules: [
                v => !!v || 'Email is required',
                v => /.+@.+\..+/.test(v) || 'Email must be valid'
            ],
      emailBool: false,
      approverEmail:'',
      schoolName: "",
      interviewRemark:"",
      deletecomment :'',
      showSuccessDialog: false,
      loading: false,
      approvalLoading: false,
      emailList: [],
      preloader: false,
      campaignName: "",
      dateToggle: 0,
      currentTimeSlotIndex: -1,
      currentSlotStart: null,
      slotsData: [],
      currentTimeSlots: [],
      currentSlotId: "",
      id: "",
      tag: "",
      dialogTag: "",
      round:1,
      isResheduled: false,
      colColors: ["", "", ""],
      emails: [],
      assignHiringManagerEmails: [],
      selectedHiringManagerEmail: "",
      editorConfig: {
        readOnly: false,
        toolbar: [
          ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', 'Link',
           'NumberedList', 'BulletedList', 'Undo', 'RemoveFormat']
        ],
        removeButtons: '',
        toolbarStartupExpanded: true,
        removePlugins: 'elementspath,resize'
      },
      editorConfigDelete: {
        readOnly: false,
        toolbar: [
          ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', 'Link',
           'NumberedList', 'BulletedList', 'Undo', 'RemoveFormat']
        ],
        removeButtons: '',
        toolbarStartupExpanded: true,
        removePlugins: 'elementspath,resize'
      },
      userStatusCheckbox: '',
      interviewerNotificationType: '',
      emailFileBlob: {},
      emailFileName: '',
      candidateDetails: {
        totalExperience: {
          years: 0,
          months: 0,
        },
        relevantExperience: {
          years: 0,
          months: 0,
        },
        noticePeriod: 0,
        currentCTC: 0.0,
        expectedCTC: 0.0,
      },
      userData:{},
      id:'',
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      ],
      isEditorValid: true,
      editorError:'',
      preloader: true,
      finalSubmitProgress: false,
      emailfileUrl:'',
      showStep1:false,
      showStep2:false,
      showSchool: true,
      rounds:[],
      roundToggleIndex:0,
      latestFeedbackRound:1,
      currentRoundFeedback:[],
      rescheduleInterviewPayload:{},
      imagePreview:'',
      userId: "",
      campaignUserData:{},
      showToggleBtn: false,
      maxFeedbackRound: 0,
      oldSlotIndex: 0,
      oldSlotId:"",
      oldEmails: '',
      hasDateTimeChanged:false,
      hasEmailChanged:false,
      hasEmailDeleted: false,
      currentRoundInterviewersCount:0,
      latestRoundFeedbackCount:0,
      disableActionSchedule: true,
      hiringManagerDetails: [],
      hiringManagerChain: [],
      hiringManagerIsAutoAssigned: null,
      hiringManagerCurrentLevel: null,
      selectedManager: {},
      interviewMode:'Online',
      oldInterviewMode:'',
      onlineInterviewLink:'',
      schoolAddress: '',
      schoolAddressError: false,
      schoolCode: '',
      isInvalidEmailDomain: false,
      isFocused: false,
      interviewStatusHistory: null,
      interviewDecision: false,
      isModify: false,
      loadingInterviewers:false,
      availableEmailsPage:[],
      availableEmailsDialog:[],
      menu: false, 
      dialogMenu: false,
      scrollElement: null,
      totalCount: 0,
      hasMoreData: null,
      pageSize: 20,
      currentPage: 1,
      dialogCurrentPage: 1,
      dialogHasMoreData: null,
      observedElements: new Set(),
      emailScrollObserver: null,
      mutationObserver: null,
      lastWatchedIndex: -1, 
      menuContent: null,
      watchedElements: [],
      scrollPending: false,
      tagDebouncer: null,
      dialogTagDebouncer: null,
      stateEmails: [],
      hrisRoundWise: '',
      hiringManagerHrisRoundWise: '',
      existingInterviewers: [],
      experienceYearsOptions: ['<1 Year', '1 Year', '2 Years', '3 Years', '4 Years', '5 Years', '6 Years', '7 Years', '8 Years', '9 Years', '10+ Years'],
      experienceMonthsOptions: ['0 Months','1 Month', '2 Months', '3 Months', '4 Months', '5 Months', '6 Months', '7 Months', '8 Months', '9 Months', '10 Months', '11 Months', '12 Months'], 
      isSchedule: true,
      // Tracks whether a fresh "schedule next round" flow was started (which soft
      // reserves a hiring manager / creates an HM draft for the incremented round).
      isNextRoundScheduleStarted: false,
      // Flips true once any interview action completes successfully (schedule,
      // reschedule, approval request, decision) so we don't release a draft the
      // user actually committed.
      interviewScheduleCompleted: false,
      // Guards clearHMDraft so it fires at most once across the leave events.
      hmDraftClearAttempted: false,
      deletedEmailandComments: [],
      checkSlotCallLoader: false,
      loadingHiringManagers: false, 
      oldHiringManager: {},
      campaignMetaData: {},
      requestSlotDialog: false,
      requestSlotCalendarDate: new Date(),
      isRequestSlotSelection: false,
      expandedSlotPanel: 'afternoon',
      requestSlotHolidays: [],
      rejectedSlot: [],
    };
  },
  async created() {
    this.id = this.$route.query.id
    this.userId = this.$route.query.userId
    this.campaignName = this.$route.query.campaignName;
    const userStatus = this.$route.query.userStatus;
    if(this.$route.query.hasOwnProperty('isSchedule')){
      this.isSchedule = this.$route.query.isSchedule == 'true'
    }
     ;
    if(userStatus) {
      this.userStatusCheckbox = userStatus;
      this.handleStatusChange()
    }
    await Promise.all([
      this.fetchCampaignAudience(),
      this.getCampaignMetaData()
    ])
    await this.scheduleInterview(this.campaignUserData)
    this.getAvalableSlots();
    await Promise.all([
      this.isReshedule(),
      this.getHiringManagerEmail()
    ])
    if (this.isSchedule) {
      await this.preselectAllForSchedule()
    }

    if(this.userData?.interViewFeedback?.length > 0){
      this.getColColors()
    }
    this.actionScheduleEligblity()
    await this.fetchRejectedSlots()
    this.preloader = false;
  },
  mounted(){
    this.initMutationObserver()
  },
  beforeDestroy(){
     this.removeScrollListener();
  },
  // In-app navigation away from the schedule page (Cancel, breadcrumbs, router
  // back). Release the draft before leaving when the flow was abandoned, but never
  // block the navigation on the network call.
  async beforeRouteLeave(to, from, next){
    try {
      await this.clearHMDraftOnLeave();
    } catch (error) {
      console.error('[clearHMDraft] beforeRouteLeave error', error);
    }
    next();
  },
  methods: {

          getHoursLeftFromRange(targetDateTime, startDateTime = new Date()) {
            const now = new Date();
            const target = new Date(targetDateTime);
            const start = new Date(startDateTime);
            
            // Validate dates
            if (isNaN(target.getTime()) || isNaN(start.getTime())) {
                throw new Error('Invalid date/time provided');
            }
            
            const timeLeft = target - now;
            
            // If we're past the target, return 0
            if (timeLeft <= 0) {
                return 0;
            }
            
            // If we're before the start, return total duration in hours
            if (now < start) {
                return (target - start) / (1000 * 60 * 60);
            }
            
            // Convert milliseconds to hours
            const hoursLeft = timeLeft / (1000 * 60 * 60);
            
            return Math.round(hoursLeft * 100) / 100; // rounded to 2 decimal places
        },
        removeExistingEmail(){
          let {interviewerEmail, interviewerName} = this.existingInterviewers.splice(this.deleteIndex, 1)[0];
          this.deletedEmailandComments.push({email: interviewerEmail, comment: this.deletecomment, deletedName: interviewerName})
          this.deleteInterviewerConfimationDialog = false;
          this.deletecomment = ""
        },
        closeDeleteConfirmationDialog(){
          this.deleteInterviewerConfimationDialog = false;
          this.deletecomment = false;
          this.deleteIndex = -1;
        },
        debouncedTagChange(){
          if(this.tagDebouncer == null){
               this.tagDebouncer = debounce(async function(newVal, oldVal) {
                if(this.tag == null ){
                  if(this.lastWatchedIndex > -1){
                    await this.getInterviewerDetails('fetch', 'page');
                    this.menu = newVal?.length > 0;
                  }
                } else {
                  this.resetAutoComplete()
                  await this.getInterviewerDetails('fetch', 'page');
                  this.scrollMenuToTop()
                  this.menu = newVal?.length > 0;
                }
              }, 500)
          }
      this.tagDebouncer()
    }, 
      debouncedDialogTagChange(){
        if(this.dialogTagDebouncer == null){
          this.dialogTagDebouncer = debounce(async function(newVal, oldVal) {
            this.resetAutoCompleteDialog()
            await this.getInterviewerDetails('fetch', 'dialog');
            this.dialogMenu = newVal?.length > 0;
          }, 500)
        }
        this.dialogTagDebouncer()
      },
      getElementIdentifier(element) {
    // Generate unique ID based on element properties
    return element.className + '_' + element.textContent.slice(0, 20) + '_' + element.offsetTop;
  },
     async onBlur() {
        this.resetAutoComplete()
        this.tag = ''
      await this.getInterviewerDetails(this.getInterviewersFromcacheOrFetch('page'), 'page')
      this.scrollMenuToTop()
  },
  resetAutoComplete(){
     this.currentPage = 1
      this.availableEmailsPage = []
       this.observedElements.clear();
        this.lastWatchedIndex = -1
  },
  resetAutoCompleteDialog(){
    this.dialogCurrentPage = 1
    this.availableEmailsDialog = []
  },
  getInterviewersFromcacheOrFetch(listType = 'page'){
    if(listType === 'dialog'){
      if((this.dialogTag == '' || this.dialogTag == null) && this.dialogCurrentPage == 1 ){
        return 'cache';
      }else {
        return 'fetch'
      }
    }
    if((this.tag == '' || this.tag == null) && this.currentPage == 1 ){
      return 'cache';
    }else {
      return 'fetch'
    }
  },
    scrollMenuToTop() {
      if(this.menuContent.length > 0){
            let element = this.menuContent[0]
          element.scrollTo({
              top: 0,
              behavior: 'smooth'
          });
        this.scrollPending = false
      } else {
        this.scrollPending = true
      }
  },
   initMutationObserver() {
    // Clean up any existing observer
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }  
  
    
    this.mutationObserver = new MutationObserver((mutations) => {
      this.menuContent = document.querySelectorAll('.v-menu__content.menuable__content.menuable__content__active'); 
      if (this.menuContent) {
      this.initIntersectionObserver();
       this.mutationObserver.disconnect(); // Stop observing once found
      }
    });
    
    // Start observing the document body for changes
    this.mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  },
   initIntersectionObserver() {
      // Create the observer
      this.emailScrollObserver = new IntersectionObserver(debounce(async(entries) => {
        let entry = entries[0]
          if (entry.isIntersecting) {
           const elementIndex = parseInt(entry.target.dataset.index, 10);
           const elementId = this.getElementIdentifier(entry.target);
             if(this.observedElements.has(`${elementId}-${elementIndex}`) || this.hasMoreData === false){
              return;  
            }
              this.observedElements.add(`${elementId}-${elementIndex}`);         
            this.lastWatchedIndex = elementIndex
            this.currentPage++
             await  this.getInterviewerDetails(this.getInterviewersFromcacheOrFetch('page'), 'page')
          }
        
      },0, {
        root: document.querySelector('.v-menu__content.menuable__content.menuable__content__active'), // The dropdown content
        threshold: 0  
      }));
    },
    observeLastTenthItem() {
  let attempts = 0;
  const maxAttempts = 10;

  const delay = () => new Promise(res => setTimeout(res, 500 * attempts));

  const tryObserve = async () => {
  const items = document.querySelectorAll('.v-select-list .v-list-item');
  const textItemsCount = this.availableEmailsPage.filter(i => !i.header).length;

    if (items.length === textItemsCount && textItemsCount > 0) {
      if (this.scrollPending) this.scrollMenuToTop();

      if (this.hasMoreData) { // Only observe if more data exists
        const idx = items.length - 5;
        if (idx >= 0) {
          this.emailScrollObserver?.disconnect();
          this.emailScrollObserver.observe(items[idx]);
        }
      }
      return;
    }

    if (attempts++ < maxAttempts) {
      await delay();
      tryObserve();
    }
  };

  tryObserve();
},
    async onAutocompleteInteraction(listType = 'page') {
      await this.getInterviewerDetails(this.getInterviewersFromcacheOrFetch(listType), listType);
    },

    removeScrollListener() {
      if (this.scrollElement && this.debouncedHandleScroll) {
        this.scrollElement.removeEventListener('scroll', this.debouncedHandleScroll)
        if (this.debouncedHandleScroll.cancel) {
          this.debouncedHandleScroll.cancel()
        }
  }
    },
    getItemIndex(){
       return  Math.random()*1000;
    }, 
    actionScheduleEligblity(){
    if(this.userData?.interviewFinalStatus?.status === "ROUND_ACCEPTED") {
      this.disableActionSchedule = false;
      const interViewFeedback = this.userData.interViewFeedback;
      const currentRound = this.userData.round;
      const interviewEmails = (this.userData.interviewDetails.allSlotDetails || this.userData.interviewDetails.interviewSlotDetails)[currentRound-1].interviewerEmails;
      const requiredRound = Number(this.userData.interviewFinalStatus.round);
      if(currentRound === requiredRound) {
        const currentRoundFeebacks = interViewFeedback.filter((interViewFeedback) =>
          Number(interViewFeedback.round) === currentRound
        )
        const currentInterViewEmails = currentRoundFeebacks.map((interViewFeedback) =>
          interViewFeedback.interviewerEmail
        )
        const uniqueInterviewEmails = [...new Set(currentInterViewEmails)];

        const totalInvited = interviewEmails.length;
        const totalFeedback = uniqueInterviewEmails.length;

        let requiredFeedback = 0;

        if(totalInvited >= 3) {
          requiredFeedback = totalInvited - 1;
        } else {
          requiredFeedback = totalInvited;
        }

        this.disableActionSchedule = totalInvited > 0 && totalFeedback >= requiredFeedback;

      }
    }
    },
    handlePaste(event) {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text');
    const emails = pastedText.split(',').map(email => email.trim());
    emails.forEach(email => {
      if (this.emailList.length < 3) {
        this.tag = email.trim();
        this.addTag();
      }
    });
  },
    handleKeyDown(event){
        if(event.key == 'Enter' || event.key == ','){
          this.addTag()
          event.preventDefault()
            return
        }

    },
    getBorderColor(){
      if(this.isInvalidEmailDomain) return 'input-invalid-border';
      if(this.isFocused) return 'input-focus';
      else return 'tag-compo';
    },
    async isValidEmailDomain(email) {
      if(email == "") return true;
      const { exists } = await UsersController.validateMDMEmail(email);
      return !!exists;
    },
    showInterviewReport(){
      this.$router.push({path: `/interviewReport/${this.id}/${this.userId}`, query: {round: this.latestFeedbackRound-1}});
    },
    goBack(){
      let query = this.$route.query;
      this.$router.push({
        path: '/campaignUser',
        query
      });
    },
    // Builds the payload the clearHMDraft endpoint expects. Returns null when the
    // required identifiers aren't available yet.
    buildClearHMDraftPayload(){
      const userId = this.userData?.userId || this.userId;
      const campaignId = this.userData?.campaignId || this.id;
      const round = this.round;
      const schoolCode = this.schoolCode || this.userData?.teachingInterests?.schoolCode || '';
      if (!userId || !campaignId || !round) {
        console.log('required data missing for clearing the draft')
        return null;
      }
      return { userId, campaignId, round, schoolCode };
    },
    // Releases the soft-reserved HM draft for in-app navigation (beforeRouteLeave,
    // Cancel, breadcrumbs). Uses the axios controller since navigation isn't tearing
    // the document down. Guarded so it runs at most once per leave.
    async clearHMDraftOnLeave(){
      if (this.hmDraftClearAttempted || !this.shouldClearHMDraft) {
        return;
      }
      const payload = this.buildClearHMDraftPayload();
      if (!payload) {
        return;
      }
      this.hmDraftClearAttempted = true;
      try {
        await UsersController.clearHMDraft(payload);
      } catch (error) {
        console.error('[clearHMDraft] failed to release HM draft', error);
      }
    },
    updateRoundFeedback(){
      this.latestFeedbackRound = this.roundToggleIndex+1
      this.currentRoundFeedback = this.campaignUserData.interViewFeedback.filter(({round})=> round == this.latestFeedbackRound)

    },
    handleStatusChange() {
      if(this.userStatusCheckbox !== ''){
        this.showStep1 = false;
      }
    },

    validateEditor() {

      const strippedContent = this.interviewRemark.replace(/<[^>]*>/g, '').trim();
      const wordCount = strippedContent.split(/\s+/).length;

            if (!strippedContent) {
              this.editorError = 'Editor content cannot be empty';
              this.isEditorValid = false;
            } else if (wordCount < 10) {
              this.editorError = 'Content must be at least 10 words';
              this.isEditorValid = false;
            } else if (strippedContent.length > 1000) {
              this.editorError = 'Content is too long (maximum 1000 characters)';
              this.isEditorValid = false;
            } else {
              this.editorError = '';
              this.isEditorValid = true;
            }
            return this.isEditorValid;
    },
    async candidateInterviewAction(){
    this.finalSubmitProgress = true
    let interviewFinalStatus = {
      currentRound: this.userData?.round || 1
    }
    this.selectedManager.hiringManagerDesignation = this.userData.teachingInterests.jobRole.hiringManagerJobRole;
    try {
      interviewFinalStatus['remark'] = this.interviewRemark
      interviewFinalStatus['status'] = this.userStatusCheckbox
      interviewFinalStatus["hiringManagerDetails"] = this.selectedManager
      interviewFinalStatus["actionTakenBy"] = "HR"
      const response = await CampaignController.submitInterviewFinalStatus({interviewFinalStatus, userId: this.campaignUserData.userId,   campaignId:this.id    })
      if(response.status === 200) {
        this.finalSubmitProgress = false;
        this.interviewDecision = true;
        this.showSuccessDialog = true
      }
      else {
        this.finalSubmitProgress = false;
        console.error(response.data.message)
        alert(response.data.message);
      }

    } catch (error) {
      this.finalSubmitProgress = false;
      console.error(error)
      alert(error);
    }
    },
    async scheduleInterview(userData) {
      try {

        const responce = await CampaignController.getAvalableSlots(userData.teachingInterests.schoolCode);
        if (responce.data.flag) {
          var slotsData = responce?.data?.data;
          if (slotsData?.length == 0 ) {
            alert("Slots are not available for this campaign now");
          } else {
            this.currentUserDataForScheduleInterview = userData;
            this.currentUserDataForScheduleInterview.slotsData = slotsData;
            this.currentUserDataForScheduleInterview.campaignId = this.id;
            this.scheduleInterviewDialog = true;
            this.currentUserDataForScheduleInterview.disableReschedule = false;
            if (userData.interviewDetails !== undefined) {
              this.currentUserDataForScheduleInterview.isResuduleFun = true;
              if(userData?.interViewFeedback !== undefined)
                this.currentUserDataForScheduleInterview.disableReschedule = true;

            } else {
              this.currentUserDataForScheduleInterview.isResuduleFun = false;
            }
            this.userData = this.currentUserDataForScheduleInterview;
            this.hrisRoundWise = this.userData.teachingInterests.jobRole.interviewerHRISUniqueRolesRoundWise[this.round || 1];
            this.hiringManagerHrisRoundWise = this.userData.teachingInterests.jobRole.hiringManagerHRISUniqueRolesRoundWise[this.round || 1];
            this.interviewStatusHistory = this.userData?.interviewStatusHistory;
          }
        }
      } catch (error) {
        alert('eror at line 743', error);
      }
    },
    async ScheduleNewInterViewRound(){
      this.userData.isResuduleFun = false;
      this.interviewMode = "Online";
      // Starting a new round reserves an HM draft for the incremented round; if
      // the user leaves without completing it, that draft must be released.
      this.isNextRoundScheduleStarted = true;
      this.interviewScheduleCompleted = false;
      this.hmDraftClearAttempted = false;
      this.round++
      this.showStep1 = true;
      this.showStep2 = true
      this.showSchool = false;
      this.userData.disableReschedule = false
      this.currentSlotId = "",
      this.currentTimeSlotIndex = 
      this.emailList = []
      this.emails = []
      this.availableEmailsPage = [];
      this.existingInterviewers = []
      this.oldEmails = ""
      this.isModify = true
      // Clear the previous round's hiring manager so it can't linger while the new
      // round's hierarchy is fetched from getHiringManagerDetails below.
      this.assignHiringManagerEmails = []
      this.selectedHiringManagerEmail = ""
      this.hrisRoundWise = this.userData.teachingInterests.jobRole.interviewerHRISUniqueRolesRoundWise[this.round || 1];
      this.hiringManagerHrisRoundWise = this.userData.teachingInterests.jobRole.hiringManagerHRISUniqueRolesRoundWise[this.round || 1];
      this.$nextTick(() => {
        const el = this.$refs.InterviewSchedule;
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      })
      // Preselect every interviewer for the new round, matching the first-time
      // schedule flow, then re-run the slot availability check for the selection.
      await this.preselectAllInterviewers()
      await this.checkSlotsForEmails()
      await this.getHiringManagerEmail()
      // Assign the new round's hiring manager straight from the getHiringManagerDetails
      // hierarchy (managers[0]), mirroring the first-time schedule flow. Skipped while
      // the hierarchy flag is off — the manager is then picked manually.
      if (this.isHiringManagerHierarchyEnabled) {
        const hierarchyManager = this.normalizeHiringManagerForPicker(this.hiringManagerDetails[0]);
        if (hierarchyManager.email) {
          this.assignHiringManagerEmails = [hierarchyManager];
          this.selectedHiringManagerEmail = hierarchyManager.email;
        }
      }
    },
    async checkSlotCall(email, name = ''){
      this.checkSlotCallLoader = true
      const res =
          await CampaignController.checkAvalableSlotsForInterviewer(
            email,
            this.currentSlotId,
            this.currentTimeSlotIndex.toString(),
            !this.isDirectBookingWindow
          );
          this.checkSlotCallLoader = false
        return {  email,
          name,
          isSlotAvalable: res?.data?.flag}
    },
   async checkSlotsForEmails(){
      // Don't run the interviewer availability check when no interviewer is
      // selected — the user is free to pick a date & time first. In edit/
      // reschedule existingInterviewers is already populated; those are only
      // re-checked when the slot actually changes (see the existing-interviewers
      // block below).
      const hasInterviewers = this.emails.length > 0 || this.existingInterviewers.length > 0;
      if (!hasInterviewers) {
        this.emailList = [];
        return;
      }
      // Drop stale availability results for interviewers that are no longer
      // selected — e.g. an unavailable interviewer removed/cleared from the
      // dropdown — so their busy error vanishes immediately. Entries for
      // still-assigned existing interviewers are kept.
      this.emailList = this.emailList.filter(i =>
        this.emails.includes(i.email) ||
        this.existingInterviewers.some(e => e.interviewerEmail === i.email)
      );
      if (this.emails.length > 0  && this.hasCompleteDateTimeSelection){
          this.emailList = await Promise.all(this.emails.map(async email => await this.checkSlotCall(email, this.availableEmailsPage.find(av => av.email == email)?.name || '')))
        }
      if(this.existingInterviewers.length && this.currentSlotId && this.currentTimeSlotIndex.toString()){
        // Already-invited interviewers are booked at their original slot. Only
        // re-check availability when the slot has actually changed (they would be
        // moved to a new time). If the slot is unchanged — e.g. simply adding a
        // new interviewer from the dropdown — re-checking flags them busy against
        // their own existing booking (false positive), so keep them available and
        // only validate the newly added interviewers above.
        const slotChanged = this.oldSlotId + this.oldSlotIndex !== this.currentSlotId + this.currentTimeSlotIndex;
        if (slotChanged) {
          this.existingInterviewers = await Promise.all(this.existingInterviewers.map(async (item)=> {
            let slot  = await this.checkSlotCall(item.interviewerEmail)
            return {...item, ...slot, name: item.interviewerName}
          }))
        } else {
          this.existingInterviewers = this.existingInterviewers.map((item) => ({
            ...item, isSlotAvalable: true, name: item.interviewerName
          }))
        }
      }
    },
    async addTag() {
        let IsEmailValid = await this.isValidEmailDomain(this.tag)
      if(IsEmailValid){
        if(this.tag !== ''){
          this.emails.push(this.tag)
        }
        this.tag = ''
        this.emails = [...new Set(this.emails)]
        this.isInvalidEmailDomain =  false;
        await this.checkSlotsForEmails()
      }
      else{
        this.isInvalidEmailDomain = true;
        await this.checkSlotsForEmails()
      }

    },
    onEditorReady(editor) {
      editor.on("afterCommandExec", function(event) {
        var commandName = event.data.name;
        if(['ckeditor_wiris_openFormulaEditor', 'ckeditor_wiris_openFormulaEditorChemistry'].includes(commandName) ) {
          setTimeout(() => {
              const wiris_license_overlays = document.querySelectorAll('.wrs_tickContainer')
              wiris_license_overlays.forEach(element => {
                element.remove();
              });
            }, 2000)
        }
      })
    },
    ondeleteEditorReady(editor) {
      editor.on("afterCommandExec", function(event) {
        let commandName = event.data.name;
        if(['ckeditor_wiris_openFormulaEditor', 'ckeditor_wiris_openFormulaEditorChemistry'].includes(commandName) ) {
          setTimeout(() => {
              const wiris_license_overlays = document.querySelectorAll('.wrs_tickContainer')
              wiris_license_overlays.forEach(element => {
                element.remove();
              });
            }, 2000)
        }
      })
    },
    handleFileUpload(event){
      const file = event.target.files[0];
      const maxSize = 512 * 1024;
      const validTypes = ['image/svg+xml', 'image/png', 'image/jpeg', 'image/webp'];
      if(file){
        if (!validTypes.includes(file.type)) {
          alert('Please upload only SVG, PNG, JPG or WEBP files');
          event.target.value = ''; // Clear the input
          return;
        }

        // Check file size
        if (file.size > maxSize) {
          alert('File size should not exceed 512KB');
          event.target.value = ''; // Clear the input
          return;
        }
        this.createImagePreview(file)
        this.emailFileName = file.name;
        this.emailFileBlob = new Blob([file], {type: file.type});

      }
    },
    clearImageFile(){
      this.emailFileName = "",
      this.emailFileBlob = {}

    },
    async uploadEmailFileInFirebase(){
        if(!this.isResumeUplaoded){
          this.isResumeUploading = true;
          const resumeRef = storageRef(storage, `email_approval/${this.emailFileName}`);
          const uploadTask = uploadBytes(resumeRef,   this.emailFileBlob);
          await Promise.all([uploadTask]);
          return  await getDownloadURL(resumeRef);

        }
    },
    clearFinalInput(){
      this.userStatusCheckbox = ""
      this.interviewRemark = ""
      this.emailFileBlob = {}
      this.approverEmail = ""
      this.emailFileName = ""

    },
    createImagePreview(file){
      const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(file);
    },
    async getColColors() {
        this.userData.interViewFeedback = this.userData.interViewFeedback.map((item, index)=>{
            if(["Not Recommended", "Below Standard"].includes(item.interviewerRecommendation)){
              item['bgClass'] =   'rejected-bg'
                // this.textColors[index] = 'rejected-txt'
            }else if( ["On Hold", "Moderately Recommended"].includes(item.interviewerRecommendation)){
              item['bgClass'] =   'hold-bg'
                // this.textColors[index] = 'hold-txt'
            } else if(["Highly Recommended","Strongly Recommended" , "Recommended"].includes(item.interviewerRecommendation)) {
              item['bgClass'] =   'recommend-bg'

                // this.textColors[index] = 'recommended-txt'
            }
            return item
        })
        await this.$nextTick()
    },
    showConfirmationDialog(){
      if(this.userData.isResuduleFun){
        // this.updateInterviewerDialog = true
      }else{
        this.showSuccessDialog = true
      }
    },
   async rescheduleInterviewAfterConsent(){
      try {
        this.rescheduleLoader = true 
          this.getInterviewEmailURL();
          const responce =
            await CampaignController.submitInterviewScheduleDetails(this.rescheduleInterviewPayload);
          if (responce.data.flag) {
            await this.scheduleInterview(this.campaignUserData)
            this.rescheduleConfimation = false
             this.rescheduleLoader = false
            this.showSuccessDialog = true
          } else {
            alert(responce.data.message);
          }
        } catch (error) {
          alert(error);
        }
    },
    // Designation needs a fallback chain rather than a plain key rename:
    // currentHiringManager is usually an interviewer-list object (see
    // hiringManagersFromInterviewers), and those carry no role at all — the ones
    // built from slot details in populateInterviewersFromSlotDetails never do —
    // so reading a single key persisted hiringManagerDesignation as null. Mirrors
    // the fallbacks currentHiringManagerHrisRole already uses for the display panel.
    resolveHiringManagerDesignation(manager = {}) {
      const email = manager.hiringManagerEmail || manager.email || manager.interviewerEmail || "";
      const hierarchyManager = (this.hiringManagerDetails || []).find((m) => m?.email === email);
      return manager.hiringManagerDesignation
        || manager.hrisUniqueRole
        || manager.designation
        || this.currentHiringManagerChainEntry?.hrisUniqueRole
        || hierarchyManager?.hrisUniqueRole
        || hierarchyManager?.hiringManagerDesignation
        || hierarchyManager?.designation
        || this.oldHiringManager?.hiringManagerDesignation
        || "";
    },
    buildHiringManagerDetailsPayload() {
      const manager = this.currentHiringManager || {};
      const hiringManagerEmail = manager.hiringManagerEmail || manager.email || manager.interviewerEmail || "";
      // Built key by key so interviewer-only fields (status, isSlotAvalable,
      // interviewerEmail, ...) can't ride along into the persisted object.
      const mapped = {
        hiringManagerName: manager.hiringManagerName || manager.name || manager.interviewerName || "",
        hiringManagerEmail,
        hiringManagerDesignation: this.resolveHiringManagerDesignation(manager),
        isHiringManager: !!hiringManagerEmail,
      };
      // Pre-hierarchy payload: just the selected manager, no chain/level metadata.
      if (!this.isHiringManagerHierarchyEnabled) {
        return mapped;
      }
      return {
        ...mapped,
        // Chain follows the schedule/edit rule (effectiveHiringManagerChain):
        // schedule (new / next round) → live getHiringManagerDetails chain;
        // edit / delete → the saved interviewSlotDetails chain of the current
        // round, so the persisted hierarchy is echoed back, not the live one.
        chain: this.effectiveHiringManagerChain?.length
          ? this.effectiveHiringManagerChain
          : (this.oldHiringManager?.chain || []),
        isAutoAssigned:
          this.hiringManagerIsAutoAssigned ?? this.oldHiringManager?.isAutoAssigned ?? false,
        currentLevel:
          this.hiringManagerCurrentLevel ?? this.oldHiringManager?.currentLevel ?? null,
      };
    },
    // The two interviewer sources use different key names: stateEmails comes from
    // the interviewer-details API ({ email, name, hrisUniqueRole, designation }),
    // while existingInterviewers uses interviewerEmail/interviewerName and carries
    // interviewer-only fields (status, isSlotAvalable). bookSlot and every reader
    // of interviewerNameAndEmail (CampaignUserView, InterviewReport,
    // InterviewFeedbackDialog) destructure { email, name }, so both lists have to
    // be flattened into that one shape instead of being spread in raw.
    normalizeInterviewerNameAndEmail(item) {
      const email = item?.email || item?.interviewerEmail || "";
      if (!email) {
        return null;
      }
      // Existing interviewers carry no role/designation of their own — backfill
      // from the interviewer list when the same person is still loaded in it.
      const listEntry = this.availableEmailsPage.find(i => i?.email === email) || {};
      return {
        email,
        name: item.name || item.interviewerName || listEntry.name || "",
        hrisUniqueRole: item.hrisUniqueRole || listEntry.hrisUniqueRole || "",
        designation: item.designation || listEntry.designation || "",
        isHiringManager: !!item.isHiringManager,
      };
    },
    // Newly added (stateEmails) + already assigned (existingInterviewers)
    // interviewers as one normalized, de-duplicated list. stateEmails can hold
    // undefined entries (autocomplete group headers have no email) and the same
    // person can sit in both lists, so blanks and repeats are dropped here.
    buildInterviewerNameAndEmailPayload() {
      const normalized = [...(this.stateEmails || []), ...(this.existingInterviewers || [])]
        .map(item => this.normalizeInterviewerNameAndEmail(item))
        .filter(Boolean);
      return [...new Map(normalized.map(item => [item.email, item])).values()];
    },
    normalizeHiringManagerForPicker(manager = {}) {
      return {
        name: manager.hiringManagerName || manager.name || "",
        email: manager.hiringManagerEmail || manager.email || "",
        hrisUniqueRole: manager.hrisUniqueRole || "",
        hiringManagerDesignation: manager.hiringManagerDesignation || manager.designation || manager.hrisUniqueRole || "",
        isHiringManager: true,
      };
    },
     reverseHiringManagerKeyMaping(obj) {
        const keyMap = {
        hiringManagerName : "name",
         hiringManagerDesignation: 'hrisUniqueRole',
         hiringManagerEmail: "email",
        isHiringManager: "isHiringManager",
      };

      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [keyMap[key] ?? key, value])
      );
    },
    async precursuryFlagCheck(){
       // flag should not exist before 
      // flag should be added on round one 
      // flag should be added only on schedule interview and not on edit or rescheudle interview 
      try{
        let payload= {
          campaignId: this.id, 
          userId: this.userId
        }
        const res = await CampaignController.setNewFeedbackFlag(payload)
    
      }catch(error){
        console.log(error)
      }
     

    },
    async saveInputs() {
      if (!this.$refs.form.validate()) {
        return;
      }
      // Warn before scheduling/rescheduling/requesting a slot when a selected
      // interviewer who is also a hiring manager is unavailable for the chosen
      // slot. Proceeding from the dialog calls submitInterviewInputs() directly.
      // NOTE: temporarily suppressed — re-enable when the HM-unavailable flow is
      // picked up again.
      // if (this.unavailableHiringManager) {
      //   this.hiringManagerUnavailableDialog = true;
      //   return;
      // }
      await this.submitInterviewInputs();
    },
    proceedHiringManagerUnavailable() {
      this.hiringManagerUnavailableDialog = false;
      this.submitInterviewInputs();
    },
    async submitInterviewInputs() {
      if (!this.$refs.form.validate()) {
        return;
      }
      // When the slot was picked from the Request Slot dialog the booking needs
      // approval first, so call the approval API instead of the bookSlot API.
      // Each primary button owns its own loader so only the clicked button spins:
      // approvalLoading drives "Send for Approval", loading drives "Schedule/Update".
      if (this.requiresApprovalFlow) {
        this.approvalLoading = true;
        await this.submitSlotApprovalRequest();
        this.approvalLoading = false;
        return;
      }
      const selectedSlot = this.getSelectedRequestSlot();
      this.loading = true;
      if (this.hasDateTimeChanged &&  this.userData.isResuduleFun) {
        this.candidateDetails.currentCTC = this.parseCTC(this.candidateDetails.currentCTC);
        this.candidateDetails.expectedCTC = this.parseCTC(this.candidateDetails.expectedCTC); 
        let data = {
          isApprovalFlow: !this.isDirectBookingWindow,
          slotData:{
              duration: {
                durationOf : selectedSlot?.end  -  selectedSlot?.start || this.currentSlotStart,
                unit: 'minutes', 
              },
            index: this.currentTimeSlotIndex?.toString(),
            slotStart: selectedSlot?.start || this.currentSlotStart,
            slotEnd: selectedSlot?.end || '',
            },
          schoolCode: this.userData.teachingInterests.schoolCode,
          hiringManagerDetails: this.buildHiringManagerDetailsPayload(),
          schoolName: this.userData.teachingInterests.schools,
          interviewerEmails: [...this.emails, ...this.existingInterviewers.map(item => item.interviewerEmail)],
          interviewerNameAndEmail: this.buildInterviewerNameAndEmailPayload(),
          slotId: this.currentSlotId,
          slotIndex: this.currentTimeSlotIndex.toString(),
          campaignId: this.userData.campaignId,
          userId: this.userData.userId,
          candidateDetails: this.candidateDetails,
          isReshedule: this.hasDateTimeChanged,
          oldSlotId: this.oldSlotId.toString(),
          oldSlotIndex: this.oldSlotIndex.toString(),
          round: this.round,
          scheduledByName: this.$store.state.userInfo.name,
          scheduledByEmail: this.$store.state.userInfo.email,
          interviewMode: this.interviewMode,
          interviewLocation: (this.interviewMode == 'Offline' ? this.schoolAddress : this.onlineInterviewLink) || '',
          deletedEmailandComments:this.deletedEmailandComments,
          isApprovalRequired: this.requiresApprovalFlow
        };
         this.rescheduleInterviewPayload = data
         this.rescheduleConfimation = true
        //  this.rescheduleInterviewAfterConsent()
        //  this.showSuccessDialog = true
      } else {
         let data = {
          isApprovalFlow: !this.isDirectBookingWindow,
          slotData:{
              duration: {
                durationOf : selectedSlot?.end  -  selectedSlot?.start || this.currentSlotStart,
                unit: 'minutes', 
              },
            index: this.currentTimeSlotIndex?.toString(),
            slotStart: selectedSlot?.start || this.currentSlotStart,
            slotEnd: selectedSlot?.end || '',
            },
          deletedEmailandComments:this.deletedEmailandComments,
          schoolName: this.userData.teachingInterests.schools,
          schoolCode: this.userData.teachingInterests.schoolCode,
          hiringManagerDetails: this.buildHiringManagerDetailsPayload(),
          interviewerEmails: [...this.emails, ...this.existingInterviewers.map(item => item.interviewerEmail) ],
          interviewerNameAndEmail: this.buildInterviewerNameAndEmailPayload(),
          slotId: this.currentSlotId,
          slotIndex: this.currentTimeSlotIndex.toString(),
          campaignId: this.userData.campaignId,
          userId: this.userData.userId,
          candidateDetails: this.candidateDetails,
          isReshedule: false,
          round: this.round,
          scheduledByName: this.$store.state.userInfo.name,
          scheduledByEmail: this.$store.state.userInfo.email,
          interviewMode: this.interviewMode,
          interviewLocation: (this.interviewMode == 'Offline' ? this.schoolAddress : this.onlineInterviewLink) || '',
          isApprovalRequired: this.requiresApprovalFlow
        };

        try {
            this.getInterviewEmailURL();
            const responce =
              await CampaignController.submitInterviewScheduleDetails(data);
          if (responce.data.flag) {
            // await this.scheduleInterview(this.campaignUserData)
            this.showSuccessDialog = true
          } else {
            alert(responce.data.message);
          }
        } catch (error) {
          alert(error);
        }
      }
      this.loading = false;
    },
    removeTag(index) {
      const email = this.emails[index]
      // Remove the availability result by email, not by index — in edit mode
      // emailList also holds the existing interviewers, so indexes don't line
      // up with emails and splicing by index left the busy entry (and its
      // error message) behind.
      const listIndex = this.emailList.findIndex(i => i.email === email);
      if (listIndex > -1) {
        this.emailList.splice(listIndex, 1);
      }
      this.emails.splice(index, 1);
      this.preserveEmailAndNames()
    },
    removeAssignHiringManagerTag(index) {
      this.assignHiringManagerEmails.splice(index, 1);
      if(!this.assignHiringManagerEmails.length){
        this.selectedHiringManagerEmail = ""
      }
    },
    // Delete is blocked once the interviewer has answered the invite, or once the
    // slot is less than 6 hours away — unless the slot itself is PENDING or
    // REJECTED, which overrides both (see isSlotPendingOrRejected).
    isInterviewerDeleteDisabled(item){
      if (this.isSlotPendingOrRejected) {
        return false
      }
      return ['accepted', 'declined'].includes(item.status?.toLowerCase()) || this.deleteWindowClosed
    },
    deleteConfirmation(item){
      // PENDING / REJECTED slots delete straight through the API — no
      // confirmation dialog and no deletion comment, because the removal is
      // persisted on the spot rather than queued for the Update submit.
      if (this.isSlotPendingOrRejected) {
        this.deleteInterviewerDirectly(item)
         this.currentPage = 1
        return
      }
      this.deleteIndex = this.existingInterviewers.findIndex((email)=> email.interviewerEmail == item)
      this.deleteInterviewerConfimationDialog = true
    },
    // Removes an interviewer from the round's slot immediately. Because the
    // change is already saved server-side there is nothing left to submit, so it
    // must NOT arm the Update button: oldEmails is re-baselined to the remaining
    // panel, which keeps emailAnddateChange's hasEmailDeleted check false.
    async deleteInterviewerDirectly(email){
      if (this.deletingInterviewerEmail) {
        return
      }
      const index = this.existingInterviewers.findIndex((i) => i.interviewerEmail === email)
      if (index === -1) {
        return
      }
      this.deletingInterviewerEmail = email
      try {
        const response = await CampaignController.deleteInterviewerFromSlot({
          campaignId: this.userData.campaignId,
          userId: this.userData.userId,
          round: this.round,
          deleteEmail: email,
        })
        if (!response?.data?.flag) {
          alert(response?.data?.message || 'Something went wrong')
          return
        }
        const [removed] = this.existingInterviewers.splice(index, 1)
        // Drop the stale availability entry too — otherwise an interviewer who
        // was flagged busy keeps the "unavailable" message and the disabled
        // action buttons alive after being removed (same reason as removeTag).
        const listIndex = this.emailList.findIndex((i) => i.email === removed.interviewerEmail)
        if (listIndex > -1) {
          this.emailList.splice(listIndex, 1)
        }
        this.syncOldEmails()
        this.deleteSuccessFullDialog = true
      } catch (error) {
        alert(error)
      } finally {
        this.deletingInterviewerEmail = ''
      }
    },
    // Re-baselines the saved interviewer list so a change that is already
    // persisted is not counted as a pending edit by emailAnddateChange.
    syncOldEmails(){
      this.oldEmails = this.existingInterviewers
        .map((item) => item.interviewerEmail)
        .sort()
        .join(',')
    },
    formatCTC(value = 0, dataProperty) {
      let formattedVal = Number(String(value).replace(/[^\d]/g, '')) || '0'; // remove non numeric characters
      formattedVal = formattedVal > 0 ? formattedVal : '0'; // restrict to positive numbers

      this.$nextTick(() => {
        this.candidateDetails[dataProperty] = new Intl.NumberFormat('en-IN').format(formattedVal); // add commas as per Indian digit format
      });
    },
    parseCTC(val){
      return val.split(',').join('');
    },
    // The reschedule API may return candidateDetails as undefined/null or with
    // missing nested fields. Merge whatever it returns onto the full default
    // shape so the template (totalExperience.years, etc.) and formatCTC always
    // have a defined object to read from and write to.
    normalizeCandidateDetails(details) {
      const defaults = {
        totalExperience: { years: 0, months: 0 },
        relevantExperience: { years: 0, months: 0 },
        noticePeriod: 0,
        currentCTC: 0.0,
        expectedCTC: 0.0,
      };
      if (!details || typeof details !== 'object') {
        return defaults;
      }
      return {
        ...defaults,
        ...details,
        totalExperience: {
          ...defaults.totalExperience,
          ...(details.totalExperience || {}),
        },
        relevantExperience: {
          ...defaults.relevantExperience,
          ...(details.relevantExperience || {}),
        },
      };
    },
    async getAssignedInterviewersStatus(emails){
      // For a slot booked outside the 3–5 window, the interviewer-status endpoint
      // returns no data until the requested slot is APPROVED. Until then, populate
      // the panel straight from the booked slot details: interviewer name/email
      // come from allSlotDetails.interviewerNameEmails (status shown as NA) and the
      // hiring manager from allSlotDetails.hiringManagerDetails.
      if (!this.isDirectBookingWindow && String(this.slotStatus).toUpperCase() !== 'ACCEPTED') {
        this.populateInterviewersFromSlotDetails();
        return;
      }
      let payload = {interviewerEmails: emails,
         slotDate: this.currentSlotId, 
          "index": this.currentTimeSlotIndex.toString(),
      }
      try {
        const res = await CampaignController.getAssignedInterviewerStatus(payload);
        if(res.status == 200){
          this.existingInterviewers = res.data.results.map((i) => {
              i.isSlotAvalable = true
            return i
          })
          if(!this.isSchedule){
            this.applyOldHiringManager(res.data?.hiringManagerDetails || {})
          }
          this.existingInterviewers.forEach( (item)=>  {
            let index = this.emailList.findIndex(i => i.email == item.interviewerEmail )
            let userDetails = {
                email: item.interviewerEmail, name: item.interviewerName,
                isSlotAvalable: true,
              }
            if(index == -1 ){
                   this.emailList.push(userDetails)
            }else {
              this.emailList.splice(index, 1, userDetails )
            }

            // return {email: item.interviewerEmail, name: item.interviewerName }
          })
        }
      }catch(err){
        console.log(err)
      }

    },
    // Selects the previously-saved hiring manager (in edit mode) from the given
    // hiringManagerDetails object, mirroring the autocomplete state the status
    // endpoint would otherwise set up.
    applyOldHiringManager(hiringManagerDetails){
      this.oldHiringManager = hiringManagerDetails || {}
      const mappedOldHiringManager = this.reverseHiringManagerKeyMaping(this.oldHiringManager)
      this.$nextTick(() => {
        const matchedHiringManager = this.hiringManagersFromInterviewers.find(
          (hm) => hm.email === mappedOldHiringManager.email
        )
        // Merge rather than replace: the interviewer-list object wins for the slot
        // and status fields, but it carries no role, so the saved designation
        // (reverse-mapped to hrisUniqueRole above) has to backfill it — otherwise
        // a round saved with a valid designation is re-saved as null on edit.
        const selectedManager = matchedHiringManager
          ? {
              ...mappedOldHiringManager,
              ...matchedHiringManager,
              hrisUniqueRole: matchedHiringManager.hrisUniqueRole || mappedOldHiringManager.hrisUniqueRole || "",
            }
          : mappedOldHiringManager
        if (selectedManager?.email && !this.availableEmailsDialog.some(i => i.email === selectedManager.email)) {
          this.availableEmailsDialog = [selectedManager, ...this.availableEmailsDialog]
        }
        this.assignHiringManagerEmails = [selectedManager]
        this.selectedHiringManagerEmail = selectedManager.email || ""
      })
    },
    // Builds the interviewer panel from the already-booked slot details when the
    // status endpoint can't yet (outside 3–5 + not APPROVED). Status is NA until
    // the requested slot is approved.
    populateInterviewersFromSlotDetails(){
      const slotDetails = this.userData?.interviewDetails?.allSlotDetails
        || this.userData?.interviewDetails?.interviewSlotDetails || []
      const roundSlot = slotDetails[this.round - 1] || {}
      const interviewerNameEmails = roundSlot.interviewerNameEmails || []
      const hiringManagerDetails = roundSlot.hiringManagerDetails || {}
      const hiringManagerEmail = hiringManagerDetails.hiringManagerEmail || ''
      
      this.existingInterviewers = interviewerNameEmails.map(item => ({
        interviewerEmail: item.email,
        interviewerName: item.name,
        status: 'NA',
        isSlotAvalable: true,
        // Carried through so a re-save keeps the role/designation this round was
        // originally booked with — the interviewer list can no longer supply them
        // once removeMatchingEmails has filtered the assigned interviewers out.
        hrisUniqueRole: item.hrisUniqueRole || '',
        designation: item.designation || '',
        // Flag the hiring manager so hiringManagersFromInterviewers (and the
        // preselect in applyOldHiringManager) can resolve it like the 3–5 path.
        isHiringManager: !!hiringManagerEmail && item.email === hiringManagerEmail,
      }))

      if(!this.isSchedule){
        this.applyOldHiringManager(hiringManagerDetails)
      }

      this.existingInterviewers.forEach((item) => {
        let index = this.emailList.findIndex(i => i.email == item.interviewerEmail)
        let userDetails = {
          email: item.interviewerEmail, name: item.interviewerName,
          isSlotAvalable: true,
        }
        if(index == -1){
          this.emailList.push(userDetails)
        }else {
          this.emailList.splice(index, 1, userDetails)
        }
      })
    },
    async isReshedule() {
      if (this.userData.isResuduleFun) {
        const slotDetails =  this.userData.interviewDetails.allSlotDetails || this.userData.interviewDetails.interviewSlotDetails  ;
        this.slotStatus = this.userData.interviewDetails.allSlotDetails?.[this.round - 1].slotStatus || '';
        this.approverDetails = this.userData?.interviewDetails?.allSlotDetails?.[this.round - 1]?.approverNameEmails?.[0] || null;
        this.schoolName = slotDetails[this.round - 1]?.schoolName;
        this.candidateDetails = this.normalizeCandidateDetails(this.userData.interviewDetails.candidateDetails);
        this.existingInterviewers = slotDetails[this.round - 1]?.interviewerEmails;
        this.oldEmails = this.existingInterviewers.sort().join(',');

        slotDetails[this.round - 1]?.interviewerEmails.forEach((email) => {
          this.emailList.push({
            email: email,
            isSlotAvalable: true,
          });
        });

        this.currentSlotId = slotDetails[this.round - 1]?.slotDate;
        this.currentTimeSlotIndex = parseInt(slotDetails[this.round - 1]?.timeSlotDetails.index);
        this.oldSlotId = slotDetails[this.round - 1]?.slotDate;
        this.oldSlotIndex = slotDetails[this.round - 1]?.timeSlotDetails.index;

        // Populate time slots for the pre-selected reschedule date
        const rescheduleSlotData = (this.slotsData || []).find(s => s.slotDate === this.currentSlotId);
        if (rescheduleSlotData) {
          this.currentTimeSlots = this.filterTimeSlots(rescheduleSlotData.subAllSlot, this.currentSlotId);
        }


        this.getInterviewerDetails('cache', 'page');
        this.formatCTC(this.candidateDetails?.currentCTC, 'currentCTC');
        this.formatCTC(this.candidateDetails?.expectedCTC, 'expectedCTC');
        await this.getAssignedInterviewersStatus(this.existingInterviewers);
      }
    },
    showStep(){
      if(this.maxFeedbackRound == 0){
        // not received the atleast one interview feedback
        this.showStep1 = true;
        this.showStep2 = false
      } else  if(this.maxFeedbackRound  < this.round && this.maxFeedbackRound > 0){
        // not received feedback for the current round
        // disable the schedule btn
        this.showStep1 = true
       this.showStep2 = true
      } else  if(this.latestFeedbackRound  == this.round){
        // enable the schedule btn
        this.showStep1 = false
        this.showStep2 = true
       }


    },
    async getHiringManagerEmail() {
      this.hiringManagerDetails = [];
      this.hiringManagerChain = [];
      this.hiringManagerIsAutoAssigned = null;
      this.hiringManagerCurrentLevel = null;
      const round = this.round || 1;
      const hiringManagerHRISRoles = this.userData.teachingInterests?.jobRole?.hiringManagerHRISUniqueRolesRoundWise[round];

      const data = {
        schoolCode: this.userData.teachingInterests.schoolCode,
        hiringManagerHRISRoles:hiringManagerHRISRoles?.join(','),
        userId: this.userData?.userId || this.userId,
        campaignId: this.userData?.campaignId || this.id,
        round
      }
      if (this.isSchedule && !this.userData?.isResuduleFun) {
        data.mode = 'hierarchy';
      }
      const query = "?" + new URLSearchParams(data).toString();

      try {
        const response = await UsersController.getHiringManagerEmail(query);
        if (response.status === 200) {
            this.hiringManagerDetails = response.data?.deadlock ? [] : (response.data?.managers || []);
            this.hiringManagerChain = response.data?.chain || [];
            this.hiringManagerIsAutoAssigned = response.data?.isAutoAssigned ?? null;
            this.hiringManagerCurrentLevel = response.data?.resolvedLevel ?? null;
            // this.emailBool = true;
        }
        else {
          console.error('Error fetching hiring manager email:');
          this.selectedManager = {
            hiringManagerName: '',
            hiringManagerEmail: this?.userData?.interviewFinalStatus?.hiringManagerDetails?.hiringManagerEmail || '',
            hiringManagerDesignation: this.userData.teachingInterests.jobRole.hiringManagerJobRole,
          }
          // this.emailBool = this?.userData?.interviewFinalStatus?.hiringManagerDetails?.hiringManagerEmail ? true : false;
        }
        if(["ROUND_ACCEPTED","SEND_TO_HIRING_MANAGER"].includes(this.userData?.interviewFinalStatus?.status)) {
          this.selectedManager = this.userData?.interviewFinalStatus?.hiringManagerDetails;
        }
      } catch (error) {
          console.error('Error fetching hiring manager email:', error);
      }
  },
    getAllRounds(){
      let data = this.campaignUserData.interViewFeedback.filter(({round})=> round !== undefined ).map(({round})=>round)
      let unq = new Set(data);
      this.rounds = [...unq].filter(item => item !== undefined)

      this.latestFeedbackRound = Math.max(...this.rounds)
      this.maxFeedbackRound = this.latestFeedbackRound
      if(this.maxFeedbackRound > 1){
        this.showToggleBtn = true
      }

      this.currentRoundFeedback = this.campaignUserData.interViewFeedback.filter(({round})=> round == this.maxFeedbackRound)
      this.roundToggleIndex = this.maxFeedbackRound-1

      this.currentRoundInterviewersCount = (this.campaignUserData?.interviewDetails?.allSlotDetails || this.campaignUserData?.interviewDetails?.interviewSlotDetails)?.[this.round-1]?.interviewerEmails?.length || 0;
      this.latestRoundFeedbackCount = Math.max(...this.rounds) == this.round ? this.getCurrentRoundFeedbackCount(data): 0

    },
    getCurrentRoundFeedbackCount(data){
      return data.filter((round)=>round == this.round).length
    },
    async getSchoolAddress(){
      let query = '?schoolCode='+this.schoolCode;
      let res = await UsersController.getSchoolAddresss(query)
      try{
        if(res?.data?.flag){
          // The API envelope is { flag, data: <payload> } (same shape used by
          // getAvalableSlots / getRejectedSlots), so the address sits under
          // res.data.data — reading res.data.schoolAddress returned undefined,
          // which made interviewLocation drop out of the JSON payload because
          // JSON.stringify omits undefined-valued keys. Read from the data
          // envelope (supporting both an object and a plain string) and
          // coalesce to '' so the value is always a string.
          const body = res.data.data;
          const address = typeof body === 'string'
            ? body
            : (body?.schoolAddress ?? body?.address ?? res.data.schoolAddress);
          this.schoolAddress = address || '';
          this.schoolAddressError = false
          if (!this.schoolAddress) {
            console.warn('[getSchoolAddress] empty address for schoolCode', this.schoolCode, res.data);
          }
        }
        else {
          this.schoolAddressError = true
        }
      } catch(error){
        console.log(error)
        this.schoolAddressError = true
      }

    },
     async resetInterviewNotificationBadge() {
            try{
               let  payload = {
                    userId :this.userId,
                    badgeName: 'showNotificationBadge'
                }
                const res = await CampaignController.resetInterviewNotificationBadge(payload)
                
            }catch(error){
                console.log(error)
            }
        },
    async fetchCampaignAudience() {
      this.dataTableLoading = true;
      let query = "?campaignId="+this.id+"&itemsPerPage="+1+"&page="+1+"&userId="+this.userId
      const audienceData = await CampaignController.getCampaignAudience(query);
      this.campaignUserData = audienceData.result.users[0]
      if(!this.campaignUserData.hasOwnProperty('feedbackV2') && this.isSchedule && !this.campaignUserData.round){
        await this.precursuryFlagCheck()
      }
      this.schoolCode = this.campaignUserData.teachingInterests.schoolCode
      if(this.campaignUserData?.showNotificationBadge){
       await this.resetInterviewNotificationBadge()
      }
      let roundIndex = this.campaignUserData?.round -1 || 0
      let slots = this.campaignUserData?.interviewDetails?.allSlotDetails || this.campaignUserData?.interviewDetails?.interviewSlotDetails || []
      let curSlot = slots[roundIndex]
      if(slots?.length && curSlot){
        this.interviewMode = curSlot.interviewMode
        this.oldInterviewMode = curSlot.interviewMode
      }
      this.getSchoolAddress()
      // data assignment
      // this.$store.dispatch('setCampaignUserData', audienceData.result.users[0])

      this.round = this.campaignUserData?.round || 1
      this.roundToggleIndex = this.round-1;

      if(this.campaignUserData?.interViewFeedback && this.campaignUserData?.interViewFeedback?.length > 0){

        this.getAllRounds()
      }else{
        this.latestFeedbackRound = 0
      }

      this.showStep()
      if(this?.campaignUserData?.hasOwnProperty('interviewFinalStatus')) {
        let finalStatus = this.campaignUserData.interviewFinalStatus
        if(["ONHOLD","REJECT","SEND_TO_HIRING_MANAGER"].includes(finalStatus.status)) {
        this.userStatusCheckbox = finalStatus.status;
        this.interviewRemark = finalStatus.remark
        }
      }


    },
    getInterviewEmailURL() {
      if(this.isProduction) {
        return;
      }
      const admin_url = window.location.origin;
      const userId = this.userData.userId;
      const campaignId = this.userData.campaignId;
      const round = this.round;
      const slotId = this.currentSlotId;
      const slotIndex = this.currentTimeSlotIndex;
      this.emails.forEach(email => {
        const feedbackFormLink = `${admin_url}#/interviewFeedback?userId=${userId}&intervieweremail=${email}&slotId=${slotId}&timeSlotId=${slotIndex}&campaignId=${campaignId}&round=${round}`;
        console.log('Feedback Form Link for', email, ':', feedbackFormLink);
      })
    },
    async downloadFile() {
      try {
        // Fetch the file
        const response = await fetch(this.emailfileUrl);
        const blob = await response.blob();

        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create temporary link element
        const link = document.createElement('a');
        link.href = url;
        link.download = 'emailApproval'; // Set desired filename

        // Append to document, click, and remove
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up the temporary URL
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Download failed:', error);
        // Handle error (show notification, etc.)
      }
    },
  async  findTimeSlots(index) {
      // §2B (PENDING): direct 3–5 slots are locked while re-requesting an
      // outside booking — ignore date-card clicks in that state.
      if (this.disableThreeToFiveSlots) return;
      // Date & time cannot be picked until an interviewer is selected.
      if (!this.hasSelectedInterviewers) return;
      this.dateToggle = index;
      this.currentSlotId = this.slotsData[index].slotDate;
      const slots = this.slotsData[index].subAllSlot;
      this.currentTimeSlots = this.filterTimeSlots(slots, this.currentSlotId);
      // Do NOT auto-select the first time slot — selecting a date only sets the date
      // and leaves the time for the user to pick, so date & time can be chosen in any
      // order. Keep the user's existing time pick if it is still valid for this date,
      // otherwise clear it.
      const matchedSlot = this.currentTimeSlots.find(
        (s) => s.index?.toString() === this.currentTimeSlotIndex?.toString()
      );
      if (matchedSlot) {
        this.currentSlotStart = matchedSlot.slotStart;
      } else {
        this.currentTimeSlotIndex = -1;
        this.currentSlotStart = null;
      }
      this.isRequestSlotSelection = false;
    await  this.checkSlotsForEmails();
    },
    async getAvalableSlots() {
      try {
        this.slotsData = this.userData?.slotsData || [];
        let selectedIndex = this.slotsData.findIndex(
          (d) => this.filterTimeSlots(d?.subAllSlot, d?.slotDate).length > 0
        );
        if (selectedIndex === -1) selectedIndex = 0;
        const slots = this.slotsData[selectedIndex]?.subAllSlot;
        const slotDate = this.slotsData[selectedIndex]?.slotDate;
        this.currentTimeSlots = this.filterTimeSlots(slots, slotDate);
        const firstSlot = this.currentTimeSlots.length > 0 ? this.currentTimeSlots[0] : null;
        this.currentSlotStart = firstSlot ? firstSlot.slotStart : null;
        this.isRequestSlotSelection = false;
      } catch (error) {
        console.log(error)
      }
    },
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },
    getInterviewerDisplayText(interviewerEmail) {
      const interviewer =
        this.availableEmailsPage.find(item => item.email === interviewerEmail) ||
        this.stateEmails.find(item => item?.email === interviewerEmail) ||
        this.existingInterviewers.find(item => item?.interviewerEmail === interviewerEmail) ||
        this.availableEmailsDialog.find(item => item.email === interviewerEmail);

      const interviewerName = interviewer?.name || interviewer?.interviewerName || "";
      return interviewerName ? `${interviewerName}  (${interviewerEmail})` : interviewerEmail;
    },
    setCurrentTimeSlotIndex(index, slotStart) {
      // §2B (PENDING): block selecting a 3–5 (direct) slot while re-requesting
      // an outside booking that is still pending approval.
      if (this.disableThreeToFiveSlots) return;
      // Date & time cannot be picked until an interviewer is selected.
      if (!this.hasSelectedInterviewers) return;
      this.currentTimeSlotIndex = index;
      this.currentSlotStart = slotStart || null;
      this.isRequestSlotSelection = false;
      this.checkSlotsForEmails()
      // this.addTag()
    },
    clearDateTimeSelection() {
      this.dateToggle = -1;
      this.currentSlotId = "";
      this.currentTimeSlotIndex = -1;
      this.currentSlotStart = null;
      this.isRequestSlotSelection = false;
      // this.currentTimeSlots = [];
    },
    getDateCardWeekday(data) {
      if (data?.weekday) {
        return String(data.weekday).slice(0, 3).toUpperCase();
      }

      const slotDate = data?.slotDate ? new Date(data.slotDate) : null;
      if (!slotDate || Number.isNaN(slotDate.getTime())) {
        return "";
      }

      return slotDate.toLocaleDateString("en-US", { weekday: "short" }).toUpperCase();
    },
    getDateCardLabel(data) {
      const slotDate = data?.slotDate ? new Date(data.slotDate) : null;
      if (!slotDate || Number.isNaN(slotDate.getTime())) {
        return data?.date ?? "";
      }

      return slotDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
      });
    },
    backToCampaignUserListingPage() {
      let query = this.$route.query;
      delete query.userId;
      delete query.campaignName;
      this.$router.push({path:'/campaignUser', query});
    },
    async getInterviewerDetails(src = 'cache', listType = 'page') {     
        const isPage = listType === 'page';
        try {
          isPage ? this.loadingInterviewers = true : this.loadingHiringManagers = true
          const jobRoleData = this.userData.teachingInterests.jobRole
          const round = this.round || 1;
          const interviewerHRISRoles = isPage ? jobRoleData.interviewerHRISUniqueRolesRoundWise[round] : jobRoleData.hiringManagerHRISUniqueRolesRoundWise[round];
          const searchQuery = isPage ? (this.tag || "") : (this.dialogTag || "");
          const pageNumber = isPage ? Number(this.currentPage) : Number(this.dialogCurrentPage);
          const hiringManagerHRISRoles =  jobRoleData.hiringManagerHRISUniqueRolesRoundWise[round];
          const schoolCode = this.schoolCode
          const queryData = {
            searchQuery,
            page: pageNumber,
            src,
            interviewerHRISRoles: interviewerHRISRoles?.join(','),
            hiringManagerHRISRoles,
           schoolCode
          };
          const query = "?" + new URLSearchParams(queryData).toString();

          const response = await UsersController.getInterviewerDetails(query);
          const fetchedEmails = response.interviewerDetails || [];
          
        
          // this.watchedElements.push(...fetchedEmails)
          if(isPage){
            this.hasMoreData = response.hasMore;
          } else {
            this.dialogHasMoreData = response.hasMore;
          }
          // Ensure selected items are preserved
          const selectedEmails = (isPage ? this.emails : this.assignHiringManagerEmails).map(selected => {
            // `emails` holds plain email strings, but `assignHiringManagerEmails` holds
            // full objects (that autocomplete uses return-object). Normalize to the
            // email string for lookups so we don't compare a string to an object below.
            const email = typeof selected === 'string' ? selected : selected?.email;
            const listRef = isPage ? this.availableEmailsPage : this.availableEmailsDialog;
            const localState = isPage ? this.stateEmails : [];
            return (
              listRef.find(i => i.email === email) ||  // from previous list
              fetchedEmails.find(i => i.email === email) ||  // from current fetch
               localState.find((i => i.email === email)) || // from local state
              (typeof selected === 'object' && selected ? selected : { email, name: "" }) // fallback: reuse the already-selected object, or a blank placeholder if all we had was an email string
            );
          });
          const mergedEmails = [
            ...new Map(
              [ ...selectedEmails, ...(isPage ? this.availableEmailsPage : this.availableEmailsDialog), ...fetchedEmails].filter(i => i.email).map(item => [item.email, item, ])
            ).values()
          ];
          if(isPage){
            this.availableEmailsPage = mergedEmails;
          }else{
            const existingEmails = new Set(mergedEmails.filter(i => i.email).map(i => i.email))
            const extraSelected = this.assignHiringManagerEmails.filter(i => i?.email && !existingEmails.has(i.email))
            this.availableEmailsDialog = [...mergedEmails, ...extraSelected];
          }
          if(isPage && this.oldEmails.length){
           this.availableEmailsPage = this.removeMatchingEmails(this.availableEmailsPage, this.oldEmails.split(','))
          }
          const groups = {}

          const listForGrouping = isPage ? this.availableEmailsPage : this.availableEmailsDialog;
          listForGrouping.forEach(item => {
            const key = item.hrisUniqueRole || 'Others'
            if (!groups[key]) groups[key] = []
            groups[key].push(item)
          })
         
          // Flatten into list with headers
          const groupedList = []
          Object.keys(groups).forEach(group => {
            groupedList.push({
              header: group,
              hrisUniqueRole: group
            })
            groupedList.push(...groups[group])
          })
          if(isPage){
            this.availableEmailsPage = groupedList
            // Observe the new last item
            await this.$nextTick()
            this.observeLastTenthItem();
          } else {
            this.availableEmailsDialog = groupedList
          }
          
        } catch (error) {
          console.error(error);
        } finally {
          if(isPage){
            this.loadingInterviewers = false;
          } else {
            this.loadingHiringManagers = false;
          }
        }
    },
    // Pages through every interviewer for the current round and selects them all.
    // Shared by the first-time schedule flow (preselectAllForSchedule) and the
    // "schedule next round" flow (ScheduleNewInterViewRound), so the interviewer
    // dropdown comes up fully preselected in both cases.
    async preselectAllInterviewers() {
      // Accumulate every page of interviewers into availableEmailsPage.
      this.resetAutoComplete();
      await this.getInterviewerDetails('fetch', 'page');
      let safety = 0;
      while (this.hasMoreData && safety++ < 50) {
        this.currentPage++;
        await this.getInterviewerDetails('fetch', 'page');
      }
      // Select all fetched interviewers. The list also holds group-header rows
      // (item.header / no email), which are skipped.
      this.emails = [
        ...new Set(this.availableEmailsPage.filter(i => !i.header && i.email).map(i => i.email))
      ];
      this.preserveEmailAndNames();
    },
    async preselectAllForSchedule() {
      try {
        // 1) Select every interviewer for this round.
        await this.preselectAllInterviewers();

        // 2) Assign the hiring manager straight from the getHiringManagerDetails
        // hierarchy (managers[0]). No interviewer-list (dialog) fetch needed.
        // With the hierarchy flag off the manager stays unselected so it has to
        // be chosen from the Hiring Manager autocomplete before scheduling.
        if (this.isHiringManagerHierarchyEnabled) {
          const hierarchyManager = this.normalizeHiringManagerForPicker(this.hiringManagerDetails[0]);
          if (hierarchyManager.email) {
            this.assignHiringManagerEmails = [hierarchyManager];
            this.selectedHiringManagerEmail = hierarchyManager.email;
          }
        }

        // 3) Re-run the availability check now that interviewers are selected.
        await this.checkSlotsForEmails();
      } catch (error) {
        console.error('Failed to preselect interviewers and hiring manager', error);
      }
    },
    removeMatchingEmails(list1, list2) {
        return list1.filter(obj => !list2.includes(obj.email));
    },
    preserveEmailAndNames(){
        this.stateEmails = this.emails.map((email)=> this.availableEmailsPage.find((availableEmail) => email == availableEmail.email))
    },
   async InterviewerAdded() {

    this.preserveEmailAndNames()
        this.emails = [...new Set(this.emails)]
        this.isInvalidEmailDomain =  false;
        await this.checkSlotsForEmails()
        if(this.tag){
            this.tag = '';
        }
        this.menu = true;
    },
    assignHiringManagerAdded() {
      if (this.assignHiringManagerEmails.length > 1) {
        this.assignHiringManagerEmails.pop();
        return;
      }
      this.assignHiringManagerEmails = [...new Set(this.assignHiringManagerEmails)];
      this.selectedHiringManagerEmail = this.assignHiringManagerEmails[0]?.email || ""
    },

  getInterviewEmailSlot(index) {
      return this.emailList[index]?.isSlotAvalable ?? true;
    },
  getInterviewerByEmail(email) {
      return this.availableEmailsPage.find(item => item.email === email);
  },
  getAssignHiringManagerEmailSlot() {
      return true;
    },

    // Custom filter as autocomplete require a field to search, for fields use custom filter
      customFilter (item, queryText, itemText) {
        const name = item.name?.toLowerCase()
        const email = item.email?.toLowerCase()
        const searchText = queryText?.toLowerCase()
        return name?.indexOf(searchText) > -1 ||
          email?.indexOf(searchText) > -1
      },
      emailcustomFilter (item, queryText, itemText) {
        const name = item.hiringManagerName?.toLowerCase()
        const email = item.hiringManagerEmail?.toLowerCase()
        const searchText = queryText?.toLowerCase()
        return name.indexOf(searchText) > -1 ||
          email.indexOf(searchText) > -1
      },
      filterTimeSlots(slots, slotDate) {
        if (!slots || !slotDate) return [];
        const today = new Date();
        const slotDateObj = new Date(slotDate);
        const isToday = slotDateObj.getDate() === today.getDate() &&
                        slotDateObj.getMonth() === today.getMonth() &&
                        slotDateObj.getFullYear() === today.getFullYear();

        if (isToday) {
          const currentHours = today.getHours();
          const currentMinutes = today.getMinutes();
          return slots.filter((slot) => {
            const [slotHour, slotMinute] = slot.slotStart.split(':').map(Number);
            return slotHour > currentHours || (slotHour === currentHours && slotMinute > currentMinutes);
          });
        }
        return slots;
      },
      restrictToWholeNumber(event,key) {
        this.$nextTick(() => {
          this.candidateDetails.noticePeriod = event.replace(/\D+/g, '');
        });
      },
      convertToMonths(exp) {
        if (!exp || !exp.years) return 0;

        const yearsStr = exp.years.trim();
        const monthsStr = (exp.months || '').trim();

        // "<1 Year" → treat as 0 years
        if (yearsStr === '<1 Year') {
          return this.extractNumber(monthsStr);
        }

        // "10+ Years" → treat as minimum 10 years
        if (yearsStr === '10+ Years') {
          return 120 + this.extractNumber(monthsStr);
        }

        // "x Years"
        const years = this.extractNumber(yearsStr);
        const months = this.extractNumber(monthsStr);

        return years * 12 + months;
      },
      extractNumber(str) {
        const match = str.match(/\d+/);
        return match ? Number(match[0]) : 0;
      },
      handleExperienceYears(){
        this.candidateDetails.relevantExperience.months = 
        this.candidateDetails.relevantExperience.years === '10+ Years' ? 
          0 : this.candidateDetails.relevantExperience.months;
          
        this.candidateDetails.totalExperience.months = 
          this.candidateDetails.totalExperience.years === '10+ Years' ? 
            0 : this.candidateDetails.totalExperience.months;
        
        this.revalidateRelevantYears();
      },
      revalidateRelevantYears(){
        this.$nextTick(() => {
          this.$refs.relevantYears?.validate();
          this.$refs.relevantMonths?.validate();
        });
      },
      async getCampaignMetaData(){
        try{
          const response = await CampaignController.getCampaignMetaData(this.id);
          this.campaignMetaData = response?.metaData || {};
        }
        catch(error) {
          console.error('campaignMetaData does not exist for campaignId:', this.id, error);
          this.campaignMetaData = {};
        }
      },
      pad(n){
        return String(n).padStart(2, '0');
      },
      isSameDay(a, b){
        return a.getFullYear() === b.getFullYear()
          && a.getMonth() === b.getMonth()
          && a.getDate() === b.getDate();
      },
      formatRequestSlotDate(date){
        return `${date.getFullYear()}-${this.pad(date.getMonth() + 1)}-${this.pad(date.getDate())}`;
      },
      parseRequestSlotDate(dateString){
        if (!dateString) {
          return null;
        }

        const [year, month, day] = String(dateString).split('-').map(Number);
        if ([year, month, day].some(Number.isNaN)) {
          return null;
        }

        return new Date(year, month - 1, day);
      },
      getRequestSlotSelectedDate(){
        return this.parseRequestSlotDate(this.currentSlotId) || new Date();
      },
      getAllRequestSlots(){
        return [...this.morningSlots, ...this.afternoonSlots, ...this.eveningSlots];
      },
      getSelectedRequestSlot(){
        return this.getAllRequestSlots().find(
          slot => String(slot.index) === String(this.currentTimeSlotIndex)
        ) || null;
      },
      buildSlotApprovalPayload(){
        const selectedSlot = this.getSelectedRequestSlot();
        return {
          candidateName: `${this.userData.personalInfo?.firstName || ''} ${this.userData.personalInfo?.lastName || ''}`.trim(),
          candidateEmail: this.userData.personalInfo?.contactInfo?.email,
          preferredJobRole: this.userData.teachingInterests?.jobRole?.HRIS_unique_role,
          hiringManagerDetails: this.buildHiringManagerDetailsPayload(),
          requesterHRISRole: this.$store.state.userInfo.HRIS_unique_role,
          round: this.round?.toString(),
          requestedSlot: {
            date: this.currentSlotId,
            slotStart: selectedSlot?.start || this.currentSlotStart,
            slotEnd: selectedSlot?.end || '',
            index: this.currentTimeSlotIndex?.toString(),
          },
          bookingPayload: {
            isApprovalFlow: !this.isDirectBookingWindow,
            round: this.round,
            interviewMode: this.interviewMode,
            interviewLocation: (this.interviewMode == 'Offline' ? this.schoolAddress : this.onlineInterviewLink) || '',
            schoolName: this.userData.teachingInterests?.schools,
            schoolCode: this.userData.teachingInterests?.schoolCode,
            slotId: this.currentSlotId,
            slotIndex: this.currentTimeSlotIndex?.toString(),
            campaignId: this.userData.campaignId,
            userId: this.userData.userId,
            slotData:{
              duration: {
                durationOf : selectedSlot?.end  -  selectedSlot?.start || this.currentSlotStart,
                unit: 'minutes', 
              },
            index: this.currentTimeSlotIndex?.toString(),
            slotStart: selectedSlot?.start || this.currentSlotStart,
            slotEnd: selectedSlot?.end || '',
            },
            scheduledByEmail: this.$store.state.userInfo.email,
            scheduledByName: this.$store.state.userInfo.name,
            deletedEmailandComments: this.deletedEmailandComments,
            interviewerEmails: [...this.emails, ...this.existingInterviewers.map(item => item.interviewerEmail)],
            interviewerNameEmails: this.buildInterviewerNameAndEmailPayload(),
            // Mirror the remaining saveInputs keys so the approval payload carries
            // the same data the bookSlot API receives.
            candidateDetails: this.candidateDetails,
            isReshedule: false,
            ...(this.userData.isResuduleFun
              ? {
                  oldSlotId: this.oldSlotId?.toString() ?? null,
                  oldSlotIndex: this.oldSlotIndex?.toString() ?? null,
                }
              : {}),
          },
        };
      },
      async submitSlotApprovalRequest(){
        const payload = this.buildSlotApprovalPayload();
        try {
          const response = await CampaignController.requestSlotApproval(payload);
          if (response && response.data && response.data.flag) {
            this.showSuccessDialog = true;
          } else {
            alert(response?.data?.message || 'Something went wrong');
          }
        } catch (error) {
          alert(error);
        }
      },
      buildRejectedSlotsQuery(){
        const params = new URLSearchParams();
        const candidateEmail = this.userData?.personalInfo?.contactInfo?.email || '';
        const campaignId = this.userData?.campaignId || this.id || '';
        if (candidateEmail) params.append('candidateEmail', candidateEmail);
        if (campaignId) params.append('campaignId', campaignId);
        params.append('status', 'REJECTED');
        params.append('round', this.round ? this.round.toString() : '');
        params.append('sortBy', 'createdAt');
        params.append('sortOrder', 'desc');
        return `?${params.toString()}`;
      },
      async fetchRejectedSlots(){
        try {
          const query = this.buildRejectedSlotsQuery();
          const response = await CampaignController.getRejectedSlots(query);
          if (response && response.data && response.data.flag) {
            this.rejectedSlot = response.data.data || [];
          } else {
            this.rejectedSlot = [];
          }
        } catch (error) {
          console.error('Failed to fetch rejected slots', error);
          this.rejectedSlot = [];
        }
      },
      isSelectedDate(day){
        return this.isSameDay(day.date, this.getRequestSlotSelectedDate());
      },
      getRequestSlotDayStart(date = new Date()){
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      },
      isPastRequestSlotDate(day){
        if (!day?.date) {
          return false;
        }

        return this.getRequestSlotDayStart(day.date) < this.getRequestSlotDayStart(new Date());
      },
      // True when the date falls in a month after the last allowed month
      // (current month + 2). Blocks trailing next-month cells rendered in the
      // current grid — selecting one would otherwise jump the calendar past the
      // disabled "next month" arrow.
      isAfterMaxRequestSlotMonth(date){
        if (!date) {
          return false;
        }
        const monthStart = new Date(date.getFullYear(), date.getMonth(), 1);
        return monthStart > this.maxRequestSlotMonth;
      },
      isTodayRequestSlotDate(date){
        return this.isSameDay(date, new Date());
      },
      getSlotStartMinutes(slot){
        if (!slot?.start) {
          return -1;
        }

        const [hours, minutes] = slot.start.split(':').map(Number);
        if (Number.isNaN(hours) || Number.isNaN(minutes)) {
          return -1;
        }

        return (hours * 60) + minutes;
      },
      isPastOrStartedRequestSlot(slot){
        if (!this.isTodayRequestSlotDate(this.getRequestSlotSelectedDate())) {
          return false;
        }

        const slotStartMinutes = this.getSlotStartMinutes(slot);
        if (slotStartMinutes < 0) {
          return false;
        }

        const now = new Date();
        const currentMinutes = (now.getHours() * 60) + now.getMinutes();
        return currentMinutes >= slotStartMinutes;
      },
      // Slots whose start falls in the 3:00 PM–5:00 PM window (15:00–17:00) are
      // the directly-bookable "3–5 window" slots — the 8 fifteen-minute slots
      // shown in the main grid (index 0–7). Those must be booked directly via
      // the grid, not requested, so they are disabled inside this dialog.
      isThreeToFiveWindowSlot(slot){
        const startMinutes = this.getSlotStartMinutes(slot);
        return startMinutes >= 15 * 60 && startMinutes < 17 * 60;
      },
      // A slot that was previously requested and REJECTED (for the selected
      // date) must stay disabled so the same date×slot cannot be re-requested.
      isRejectedSlot(slot){
        if (!slot || !this.rejectedSlot?.length) {
          return false;
        }

        const selectedDate = this.currentSlotId;
        if (!selectedDate) {
          return false;
        }

        return this.rejectedSlot.some(rejected => {
          const requested = rejected?.requestedSlot;
          return requested
            && requested.date === selectedDate
            && String(requested.index) === String(slot.index);
        });
      },
      isRequestSlotDisabled(slot){
        return this.isPastRequestSlotDate({ date: this.getRequestSlotSelectedDate() })
          || this.isPastOrStartedRequestSlot(slot)
          || this.isThreeToFiveWindowSlot(slot)
          || this.isRejectedSlot(slot);
      },
      hasAvailableRequestSlots(slots = []){
        return slots.some(slot => !this.isRequestSlotDisabled(slot));
      },
      getDefaultRequestSlotPanel(){
        const selectedDate = this.getRequestSlotSelectedDate();
        const isToday = this.isTodayRequestSlotDate(selectedDate);
        const currentHour = new Date().getHours();
        let preferredPanel = 'morning';

        if (isToday) {
          if (currentHour >= 16) {
            preferredPanel = 'evening';
          } else if (currentHour >= 12) {
            preferredPanel = 'afternoon';
          }
        }

        const panelSlotMap = {
          morning: this.morningSlots,
          afternoon: this.afternoonSlots,
          evening: this.eveningSlots,
        };

        if (this.hasAvailableRequestSlots(panelSlotMap[preferredPanel])) {
          return preferredPanel;
        }

        return ['morning', 'afternoon', 'evening'].find(
          panel => this.hasAvailableRequestSlots(panelSlotMap[panel])
        ) || preferredPanel;
      },
      getRequestSlotPanelForSelection(){
        const selectedSlot = this.getSelectedRequestSlot();
        if (!selectedSlot) {
          return this.getDefaultRequestSlotPanel();
        }

        if (this.morningSlots.some(slot => slot.index === selectedSlot.index)) {
          return 'morning';
        }
        if (this.afternoonSlots.some(slot => slot.index === selectedSlot.index)) {
          return 'afternoon';
        }
        return 'evening';
      },
      syncRequestSlotDialogState(){
        if (!this.currentSlotId) {
          this.currentSlotId = this.formatRequestSlotDate(new Date());
        }
        const selectedDate = this.getRequestSlotSelectedDate();
        this.requestSlotCalendarDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
        this.expandedSlotPanel = this.getRequestSlotPanelForSelection();
      },
      openRequestSlotDialog(){
        // Don't allow requesting a slot until an interviewer is selected.
        if (!this.hasSelectedInterviewers) return;
        // Fresh scheduling opens the dialog on today's date (same YYYY-MM-DD
        // format the calendar uses everywhere). Clear the time selection along
        // with it — a 3–5 index carried over from the main page belongs to a
        // different date. Runs before the sync so the calendar month follows.
        // Skipped once a slot has been confirmed here (isRequestSlotSelection):
        // reopening to change that slot must show it still selected. Cancel and
        // the 3–5 grid both reset the flag, so those still clear as before.
        if(this.isSchedule && !this.isRequestSlotSelection){
          this.currentSlotId = this.formatRequestSlotDate(new Date());
          this.currentTimeSlotIndex = "";
          this.currentSlotStart = null;
        }
        this.syncRequestSlotDialogState();
        this.requestSlotDialog = true;
      },
      // Cancel: selecting a date/time inside the dialog mutates the shared
      // currentSlotId/currentTimeSlotIndex immediately (and is only confirmed on
      // Proceed), so discard that unconfirmed pick via clearDateTimeSelection before
      // closing — same as the main "Clear Selection" button.
      cancelRequestSlotDialog(){
        this.clearDateTimeSelection();
        this.requestSlotDialog = false;
      },
      onRequestSlotPanelChange(panelName, value){
        this.expandedSlotPanel = value === 0 ? panelName : null;
      },
      selectDate(day){
        if (this.isPastRequestSlotDate(day) || day?.isSunday || this.isAfterMaxRequestSlotMonth(day?.date)) {
          return;
        }

        this.currentSlotId = this.formatRequestSlotDate(day.date);
        this.requestSlotCalendarDate = new Date(day.date.getFullYear(), day.date.getMonth(), 1);
        this.currentTimeSlotIndex = "";
        this.currentSlotStart = null;
        this.expandedSlotPanel = this.getDefaultRequestSlotPanel();
      },
      selectRequestSlot(slot){
        if (this.isRequestSlotDisabled(slot)) {
          return;
        }

        this.currentTimeSlotIndex = String(slot.index);
        this.currentSlotStart = slot.start;
        // Date + time are now both selected → re-check interviewer availability
        // for this slot (mirrors the outside flow's setCurrentTimeSlotIndex).
        this.checkSlotsForEmails();
      },
      prevMonth(){
        if (this.isPrevRequestMonthDisabled) {
          return;
        }
        this.requestSlotCalendarDate = new Date(
          this.requestSlotCalendarDate.getFullYear(),
          this.requestSlotCalendarDate.getMonth() - 1,
          1
        );
      },
      nextMonth(){
        if (this.isNextRequestMonthDisabled) {
          return;
        }
        this.requestSlotCalendarDate = new Date(
          this.requestSlotCalendarDate.getFullYear(),
          this.requestSlotCalendarDate.getMonth() + 1,
          1
        );
      },
      goToday(){
        const today = new Date();
        this.requestSlotCalendarDate = new Date(today.getFullYear(), today.getMonth(), 1);
        this.currentSlotId = this.formatRequestSlotDate(today);
        this.currentTimeSlotIndex = "";
        this.currentSlotStart = null;
        this.isRequestSlotSelection = false;
        this.expandedSlotPanel = this.getDefaultRequestSlotPanel();
      },
      generateSlots(startMinutes, endMinutes, startIndex = 8){
        const slots = [];
        let slotIndex = startIndex;
        for (let s = startMinutes; s + 14 <= endMinutes; s += 15) {
          const e = s + 14;
          const start = `${this.pad(Math.floor(s / 60))}:${this.pad(s % 60)}`;
          const end = `${this.pad(Math.floor(e / 60))}:${this.pad(e % 60)}`;
          slots.push({ start, end, key: `${start}-${end}`, index: slotIndex });
          slotIndex += 1;
        }
        return slots;
      },
      onProceedRequestSlot(){
        const selectedSlot = this.getSelectedRequestSlot();
        this.currentTimeSlotIndex = selectedSlot ? String(selectedSlot.index) : "";
        this.currentSlotStart = selectedSlot?.start || null;
        this.isRequestSlotSelection = !!selectedSlot;
        this.requestSlotDialog = false;
        // Re-check interviewer availability for the confirmed slot so the main
        // view (emailList / BusySlotNames) reflects the date & time just chosen.
        if (selectedSlot) {
          this.checkSlotsForEmails();
        }
      },
  }
};
</script>
<style>
.request-slot-footer {
  flex: 0 0 auto;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
}
.request-slot-header {
  flex: 0 0 auto;
}
.request-slot-body {
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.request-slot-body::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none;
}
.request-slot-dialog {
  overflow: hidden;
}
.request-slot-card {
  overflow: hidden;
}
.request-slot-dialog .request-slot-inner-card.v-sheet.v-card {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
@media (min-width: 960px) {
  .request-slot-body {
    overflow: hidden;
  }
  .request-slot-row {
    height: 100%;
    flex-wrap: nowrap;
  }
  .request-slot-col {
    display: flex;
    min-height: 0;
  }
  .request-slot-inner-card {
    flex: 1 1 auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
  }
  .request-slot-inner-card .rs-calendar {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }
  .request-slot-inner-card .rs-calendar-body {
    overflow-y: auto;
    flex: 1 1 auto;
    min-height: 0;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .request-slot-inner-card .rs-calendar-body::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
    display: none;
  }
  .request-slot-inner-card .slot-accordion-scroll {
    flex: 1 1 auto;
    overflow-y: auto;
    min-height: 0;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .request-slot-inner-card .slot-accordion-scroll::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
    display: none;
  }
}
.clear-selection {
  color: #3F41D1 !important;
  background: #E1E8F5 !important;
}
.date-time-selection-card {
  border: 1px solid #e6e8f0 !important;
  border-radius: 18px !important;
  box-shadow: 0 8px 24px rgba(18, 32, 73, 0.08) !important;
}
.selected-slot-info {
  background: #ffffff;
  font-size: 14px;
  line-height: 1.35;
  color: #737887;
}

.date-time-clear-btn.v-btn {
  min-width: 168px;
  height: 40px !important;
  padding: 0 20px !important;
  color: #8e8e8e !important;
  background: #e6e6e6 !important;
  box-shadow: none !important;
  text-transform: none;
}

.date-time-clear-btn.v-btn.v-btn--disabled {
  color: #b8b8b8 !important;
  opacity: 1 !important;
}

.date-selection-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border: 1px solid #d8dde8;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
}

.date-selection-item {
  border: none;
  border-right: 1px solid #d8dde8;
  background: #ffffff;
  min-height: 64px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.date-selection-item:last-child {
  border-right: none;
}

.date-selection-item--active {
  background: #E1E8F5;
  /* box-shadow: inset 0 0 0 1px #3f41d1; */
}

.date-selection-grid .date-selection-item:first-child {
  border-radius: 11px 0 0 11px;
}

.date-selection-grid .date-selection-item:last-child {
  border-radius: 0 11px 11px 0;
}

.date-selection-item--disabled,
.date-selection-item:disabled {
  background: #f4f5f7;
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.date-selection-item__weekday {
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0.08em;
  color: #7f8493;
}

.date-selection-item__date {
  font-size: 16px;
  line-height: 1.2;
  color: #22252f;
}

.date-slot-grid {
  display: grid !important;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.date-slot-grid .slot-item {
  width: auto;
}

.date-slot-item {
  min-height: 56px;
  border: 1px solid #d8dde8 !important;
  box-shadow: none !important;
  font-size: 16px;
  font-weight: 400;
}

/* Match the disabled date cards above. Vuetify's default v-card disabled state
   only dims element children (the slot label is a bare text node, so nothing
   visibly changes); apply the same muted grey treatment as
   .date-selection-item--disabled so a disabled slot reads as clearly inactive.
   Higher specificity than .schedule-card .SI-time-card overrides its white bg. */
.schedule-card .date-slot-item.v-card--disabled {
  background: #f4f5f7 !important;
  cursor: not-allowed !important;
  opacity: 0.5;
  pointer-events: none;
}

.date-time-selection-footer {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.date-time-selection-or {
  text-align: center;
  font-size: 18px;
  color: #666b78;
}

.date-time-selection-request {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
}

.requested-slot-info .requested-slot-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}

.requested-slot-info .requested-slot-value {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.requested-slot-info .requested-slot-status {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.requested-slot-info--rejected .requested-slot-label,
.requested-slot-info--rejected .requested-slot-value,
.requested-slot-info--rejected .requested-slot-status,
.requested-slot-info--rejected .date-time-selection-help {
  color: #d32f2f !important;
}

.date-time-selection-help {
  max-width: 460px;
  font-size: 14px;
  line-height: 1.35;
  color: #737887;
}

.request-slot-trigger.v-btn {
  min-width: 170px;
  height: 44px !important;
  padding: 0 24px !important;
  border-color: #3f41d1 !important;
  color: #3f41d1 !important;
  text-transform: none;
  box-shadow: none !important;
}
.rounded-list-bg{
  background-color: #e1E8F5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.input-focus {
  border-color: #3f41d1 !important;
}
.input-invalid-border {
  border-color: #e6393e !important;
  border-radius: 0;
}
.invalid-message {
  color: #e6393e;
  font-size: 12px;
  line-height: 1.5;
  margin: 4px 0px 0px 8px;
  font-weight: 400;
}
.h-50px{
  height: 50px;
}
.side-container {
  background-color: white;
  border-radius: 8px;
  padding: 24px;
}

.schedule-columns-row {
  min-height: calc(100vh - 280px);
}
.schedule-lhs-col {
  position: relative;
}

.schedule-lhs-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.schedule-lhs-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* Hidden scrollbar (still scrollable) */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.schedule-lhs-scroll::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}

.hold-bg{
    background-color: rgba(233, 182, 94, 0.24);
}
.recommend-bg{
    background-color: rgba(95, 159, 104, 0.24);
}
.rejected-bg {
    background-color: #F9DBE1;
}

.interview-remark{
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Adjust the number of lines for your needs */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: left;
}

.my-card {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  min-height: 205px;
}

.dotted-border{
  border: 2px dashed var(--gray-04);
  padding: 20px;
  border-radius: 16px;
}

.interview-main--container {
  min-height: 100vh;
  .m-ckeditor {
    height: 115px;
  }
}

.delete-interview-pop {
 
  .m-ckeditor {
    height: 175px;
  }
}

.schedule-card--container {
  border: 1px solid #0000001F;
}

.schedule-card--container, .subject-level--container,
.job-role--container, .select-slot--container {
  gap: 20px;
}

.interview-text--label {
  font-size: 14px;
  width: 124px;
  white-space: nowrap;
  ~ p {
    font-size: 14px;
    font-family: "GraphikMedium", sans-serif !important;
    font-weight: 500;
  }
}

.interview-text--value {
  max-width: 244px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.interview-job--location {
  width: 130px;
}

.interviewer-name-cell {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
}

.interviewer-name-text {
  display: block;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.interviewer-info-icon {
  flex-shrink: 0;
}

.hiring-manager-header {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.interview-date--toggle {
  margin: 30px 0px;
  .v-btn {
    height: 55px !important;
    background: var(--white) !important;
  }
}

.schedule-card {
  .SI-time-card {
    background: var(--white) !important;
    border: 1px solid #0000001F !important;
  }
}

.round-card {
  .v-messages {
    display: none;
  }
  .v-input__slot {
    display: block;
    margin: 0;
  }
  .text-btn {
    height: 30px !important;
  }
  .v-label {
    font-size: 16px !important;
    margin-left: 10px;
  }
}

@media (max-width: 960px) {
  .date-selection-grid,
  .date-slot-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .date-time-selection-request {
    flex-direction: column;
    align-items: stretch;
  }

  .date-time-selection-help,
  .request-slot-trigger.v-btn {
    max-width: none;
    width: 100%;
  }
}

.current-round--card {
  min-height: 150px;
}

.interview-round--comment {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.interview-card--label {
  width: 116px;
}

.interview-details {
  gap: 20px;
  span {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 8px;
  }
}

.interview-user--email {
  font-size: 14px;
  font-family: "GraphikMedium", sans-serif !important;
  font-weight: 500;
}
.delete-interview-pop{
   max-width: 466px;
     margin: auto;
}
.interview-schedule--popup {
  max-width: 366px;
  margin: auto;
  .interview-popup--text {
    font-size: 24px;
    font-family: "GraphikMedium", sans-serif !important;
    font-weight: 500;
    margin: 20px 0 !important;
    text-align: center;
  }
  .v-radio {
    align-items: start;
  }
}

.v-dialog {
  box-shadow: none;
}

.header {
  position: fixed;
  z-index: 1;
}

section {
  padding-top: 40px;
}

.round-text {
  white-space: nowrap;
}

.toggle-btn--container {
  display: flex;
  justify-content: end;
  .v-btn {
    padding: 10px 24px !important;
    color: var(--blue-01);
    font-family: "GraphikMedium", sans-serif !important;
    font-weight: 500;
  }
  .v-btn-toggle {
    border: 1px solid var(--blue-01);
  }
}

.skill-btn {
  border-right-color: var(--blue-01) !important;
  &.v-item--active {
    font-family: "GraphikMedium", sans-serif !important;
    font-weight: 500;
  }
}

.cursror-pointer{
  cursor: pointer;
}
.text--error{
  color: var(--error);
}

/* If you want to hide scrollbar from the dropdown menu */
.v-menu__content  {
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-left: 0px;
}

.v-menu__content ::-webkit-scrollbar {
  display: none;
}
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 24px;
}

.slot-item {
  width: calc(25% - 8px);
}

.request-slot-dialog .v-card[data-disabled="true"] {
  color: #A0A6B2 !important;
  border-color: #E1E4EA !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}
/* v-item is renderless — it merges its class onto the v-card root, so
   .slot-item and .v-card are the same DOM element. Target via the grid parent. */
.request-slot-dialog .schedule-card .slot-item {
  width: 100%;
  white-space: nowrap;
  margin: 0 !important;
}
.request-slot-dialog .schedule-card {
  display: grid !important;
  /* 140px safely fits the longest "HH:MM - HH:MM" label (≈119px) at any DPI.
     auto-fill gives 4 cols on wide panels, 3 on medium, 2 on narrow — never
     fewer than what fits — so the row count adapts without text ever wrapping. */
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 8px;
}

.rs-calendar {
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  overflow: hidden;
  background-color: #ffffff;
}
.rs-calendar .rs-calendar-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background-color: #ffffff !important;
}
.rs-calendar .rs-calendar-header-cell {
  padding: 14px 16px;
  color: #1F2937 !important;
  font-weight: 500 !important;
  font-size: 14px;
  line-height: 1.25;
  border-left: 1px solid #E5E7EB;
}
.rs-calendar .rs-calendar-header-cell:first-child {
  border-left: none;
}
.rs-calendar-body {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.rs-calendar-cell {
  min-height: 72px;
  padding: 10px 14px;
  border-top: 1px solid #E5E7EB;
  border-left: 1px solid #E5E7EB;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: background-color 0.15s ease;
}
.rs-calendar-cell:nth-child(7n+1) {
  border-left: none;
}
.rs-calendar-cell:hover {
  background-color: #F7F8FC;
}
.rs-calendar-cell--disabled {
  background-color: #F5F6F8;
  cursor: not-allowed;
  pointer-events: none;
}
.rs-month-nav--disabled {
  opacity: 0.35;
}
.rs-calendar-cell--disabled .rs-calendar-day {
  color: #B6BBC6;
}
.rs-calendar-day {
  color: #1F2937;
  line-height: 1.2;
}
.rs-calendar-cell--out .rs-calendar-day {
  color: #C1C7D0;
}
.rs-calendar-cell--today .rs-calendar-day {
  color: #B2AC88;
  font-weight: 600;
}
.rs-calendar-cell--selected {
  background-color: #E1E8F5;
}
.rs-calendar-cell--selected .rs-calendar-day {
  color: #3F41D1;
  font-weight: 600;
}
.rs-calendar-holiday {
  width: 100%;
  min-width: 100%;
  margin-top: 10px;
  padding: 4px 8px;
  background: #ececec;
  border-radius: 0;
  box-sizing: border-box;
  color: #5f6368;
  font-size: 12px;
  line-height: 1.1;
  text-align: left;
}

.request-slot-dialog .schedule-card.gap-10 {
  gap: 8px;
}

.outlined-border {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.VueCarousel-navigation-button {
  color: var(--blue-01) !important;
}

.slot-error{
  color: #e6393e !important;
}

.hm-unavailable-chip {
  background: #fdecea !important;
  color: #e6393e !important;
  font-weight: 500;
}

.assign-hiring-autocomplete {
  .v-input__control > .v-input__slot {
    min-height: 56px;
    border-radius: 12px !important;
  }
  &.v-text-field--outlined .v-input__control > .v-input__slot {
    border-color: #c7c7c7 !important;
  }
  .v-label {
    color: #6b6b6b !important;
    font-weight: 500;
  }
  .v-select__selections {
    padding-left: 12px;
  }
  .v-input__append-inner {
    margin-top: 10px;
  }
  .v-select__selection {
    margin: 0;
  }
}

.assign-hiring-selection {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.assign-hiring-menu {
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  .v-list-item {
    min-height: 40px;
  }
}

.email-overflow-tooltip {
  background-color: var(--white) !important;
  color: var(--primary) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px;
  opacity: 1 !important;
  padding: 12px 16px;
}
</style>
